import { _ as __rest, a as __awaiter } from './tslib.es6-b97b9ccd.js';
import React__default, { useMemo, useEffect, useContext, useState, useRef, useCallback } from 'react';
import { V as VideoType } from './index-57001be3.js';
import { i as isInternalLink, V as VideoItem, L as LanguageSwitcher } from './index-b131d036.js';
import { a as CARE_LOCALES, b as CARE_BOOKING_LOCALES, T as TOGETHER_LOCALES, E as ECOM_LOCALES, c as VIDEO_LOCALES, S as STATIC_PAGES, L as LOCALE_SPECS } from './index-d722456d.js';
import { g as getCurrentBaseUrl, a as getCurrentSsoUrl, b as getTogetherApiDomain, c as getDiscoverApiDomain, n as normalizeLink, e as normalizeLinkSlash, d as getCareApiDomain } from './normalizeLink-dc941d98.js';
import { a as formatCommunity, b as formatPost } from './dataTransform-851fe21a.js';
import { ArrowRight, ChatAi } from '@hhgtech/icons/other';
import { createStyles, Box, Indicator, useMantineTheme } from '@mantine/core';
import { L as Logo$1 } from './index-c14e1320.js';
import throttle from 'lodash/throttle';
import { I as Input } from './index-ed1b642a.js';
import '@mantine/dates';
import { C as CommonGAssets } from './index-2bf5f78a.js';
import './useMantineLocale-738fc2b0.js';
import { T as Text } from './index-5c0e8412.js';
import { B as Button$1 } from './index-966f3431.js';
import './index.styles-2ae2bbf8.js';
import './translationsContext-f94ca99c.js';
import '@mantine/hooks';
import { g as getBoundariesFromMediaQueryKey, M as MediaQueries } from './utils-1a4cbdae.js';
import './other-cef0261a.js';
import './index-6a7dde31.js';
import { L as LOCALISED_SLUGS } from './constants-1e984837.js';
import styled from '@emotion/styled';
import { u as useCSSFocusPopupHelper, N as NavigationProfileButton } from './index-8c190b12.js';
import { u as useSSOV2Store, I as IS_SSOV2_ENABLED } from './store-a147d34d.js';
import { i as domainLocalesMarryBaby } from './utils-c0714c25.js';
import { domainLocales } from './constantsDomainLocales.js';
import { L as LOCALIZED_SLUGS } from './constants-c6cbd6b8.js';
import { u as useTranslations } from './index-f8dbf8e4.js';
import { theme } from './miscTheme.js';
import { H as Heading } from './index-c807b0bb.js';
import { Close, Logo } from '@hhgtech/icons/core';
import { I as Indicator$1 } from './index-c3c35151.js';
import { u as useIsInit } from './useIsInit-2050867e.js';
import { setDefaultClass } from './miscDefaultClassWrapper.js';
import { B as Button } from './index-f9473851.js';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { U as UserAvatar } from './index-af7a0b48.js';
import formatString from 'string-format';
import { C as Container } from './index-be290ad5.js';
import debounce from 'lodash/debounce';
import { L as LOCALE } from './Locale-e37edea6.js';
import { g as getDataWithCache } from './core-503d0e19.js';

const getEcomUrl = ({ path, locale, }) => {
    var _a;
    return `/shop/${(_a = LOCALISED_SLUGS[locale || 'vi-VN']) === null || _a === void 0 ? void 0 : _a[path]}/`;
};

var useStyles = createStyles(() => {
    return {
        root: {
            textDecoration: 'none',
        },
        iconText: {
            color: '#fff',
        },
    };
});

const CartBadge = (_a) => {
    var { count, styles, className, classNames, locale } = _a, boxProps = __rest(_a, ["count", "styles", "className", "classNames", "locale"]);
    const { classes, cx } = useStyles(undefined, {
        name: 'CartBadge',
        styles,
        classNames,
    });
    return typeof count !== 'undefined' ? (React__default.createElement(Box, Object.assign({ component: "a", href: getEcomUrl({ path: 'CART', locale }), className: cx(classes.root, className) }, boxProps),
        React__default.createElement(Indicator, { withBorder: true, color: 'red', size: 20, disabled: count === 0, label: React__default.createElement(Text, { className: classes.iconText, size: "s5" }, count > 99 ? '99+' : count) },
            React__default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
                React__default.createElement("path", { d: "M5.308 21.5q-.748 0-1.278-.53a1.74 1.74 0 0 1-.53-1.278V8.308q0-.75.53-1.278.53-.53 1.278-.53H7.5q0-1.873 1.313-3.187Q10.127 2 12 2t3.187 1.313T16.5 6.5h2.192q.749 0 1.278.53.53.53.53 1.278v11.384q0 .749-.53 1.278-.53.53-1.278.53zm0-1.5h13.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8.308a.3.3 0 0 0-.096-.212.3.3 0 0 0-.212-.096H5.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v11.384q0 .116.096.212a.3.3 0 0 0 .212.096M9 6.5h6q0-1.25-.875-2.125A2.9 2.9 0 0 0 12 3.5q-1.25 0-2.125.875A2.9 2.9 0 0 0 9 6.5m2.985 7q1.695 0 3.047-1.148 1.35-1.148 1.335-2.606a.74.74 0 0 0-.207-.528.7.7 0 0 0-.527-.218.7.7 0 0 0-.471.182 1 1 0 0 0-.295.506 2.8 2.8 0 0 1-1.036 1.665 2.9 2.9 0 0 1-1.846.647 2.93 2.93 0 0 1-1.854-.647A2.73 2.73 0 0 1 9.1 9.688q-.086-.34-.278-.514A.66.66 0 0 0 8.367 9a.72.72 0 0 0-.534.218.72.72 0 0 0-.216.528q0 1.457 1.336 2.606 1.335 1.148 3.032 1.148", fill: "#2D87F3" }))))) : null;
};

const StyledDisplayWrapper = styled.div `
  &.block-show {
    display: block;
  }
`;

const DisplayWrapper = ({ forceDisplay, mediaQueryKey, children, className, style, }) => {
    // use CSS to display or not
    const [lowerBoundValue, upperBoundValue] = useMemo(() => getBoundariesFromMediaQueryKey(mediaQueryKey), [mediaQueryKey]);
    return (React__default.createElement(StyledDisplayWrapper, { lowerBound: forceDisplay ? 0 : lowerBoundValue, upperBound: forceDisplay ? 0 : upperBoundValue, className: className, style: style }, children));
};

var styles$2 = {"menuContainer":"y5VJdvw","menuIcon":"oVhOSCy","menuIconWrapper":"pX8OXTM"};

const useNavConfig = ({ locale, projectType, siteType, enableBookingBtn, }) => {
    const config = useMemo(() => {
        const enableSearchBar = projectType === 'discover' ||
            projectType === 'together' ||
            projectType === 'marryBaby' ||
            (projectType === 'profile' && siteType === 'marryBaby');
        const enableNavCare = siteType !== 'marryBaby' &&
            projectType !== 'marryBaby' &&
            CARE_LOCALES.includes(locale);
        const enableNavCareBooking = enableBookingBtn &&
            projectType !== 'marryBaby' &&
            projectType === 'discover' &&
            siteType !== 'marryBaby' &&
            CARE_BOOKING_LOCALES.includes(locale);
        const enableNavTogether = projectType === 'marryBaby' || TOGETHER_LOCALES.includes(locale);
        const enableNavDiscover = true;
        const enableNavHealthTools = true;
        const enableProfileMySaved = true;
        const enableNavEcom = siteType !== 'marryBaby' && ECOM_LOCALES.includes(locale);
        const enableProfileEcom = siteType !== 'marryBaby' && ECOM_LOCALES.includes(locale);
        const enableProfileMyHealth = true;
        const enableNavVideo = VIDEO_LOCALES.includes(locale);
        const baseUrl = getCurrentBaseUrl(locale, siteType === 'marryBaby');
        let fixBaseUrl = baseUrl;
        if (typeof window !== 'undefined') {
            if (fixBaseUrl.includes('//id.'))
                fixBaseUrl = fixBaseUrl.replace('id.', '');
            if (fixBaseUrl.includes('//staging-id.'))
                fixBaseUrl = fixBaseUrl.replace('staging-id.', 'discover.');
        }
        const ssoUrl = getCurrentSsoUrl(locale, siteType === 'marryBaby');
        const statics = (() => {
            return {
                HOME_PAGE_URL: fixBaseUrl,
                CARE_URL_FE: `${fixBaseUrl}/care`,
                TOGETHER_URL_FE: `${fixBaseUrl}/community`,
                VIDEO_URL_FE: `${fixBaseUrl}/videos`,
                SSO_URL: ssoUrl,
                TOGETHER_API: getTogetherApiDomain(),
                DISCOVER_API: getDiscoverApiDomain(locale),
            };
        })();
        return {
            enableSearchBar,
            enableNavCare,
            enableNavCareBooking,
            enableNavTogether,
            enableNavEcom,
            enableProfileEcom,
            enableNavVideo,
            enableProfileMyHealth,
            enableNavDiscover,
            enableNavHealthTools,
            enableProfileMySaved,
            statics,
        };
    }, []);
    return config;
};

const NavigationContext = React__default.createContext({});
const NavigationProvider = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    const [currentUrl, setCurrentUrl] = React__default.useState(() => {
        return (props.currentUrl ||
            `https://${props.siteType === 'marryBaby'
                ? domainLocalesMarryBaby[props.locale || 'en-PH']
                : domainLocales[props.locale || 'en-PH']}${props.projectType === 'together'
                ? '/community'
                : props.projectType === 'ecom'
                    ? '/ecom'
                    : props.projectType === 'care'
                        ? '/care'
                        : ''}/`);
    });
    useEffect(() => {
        const update = () => {
            setCurrentUrl(window.location.href);
        };
        window.addEventListener('popstate', update);
        update();
        return () => {
            window.removeEventListener('popstate', update);
        };
    }, []);
    const configs = useNavConfig({
        locale: props.locale,
        projectType: props.projectType,
        siteType: props.siteType,
        enableBookingBtn: props.enableBookingBtn,
    });
    return (React__default.createElement(NavigationContext.Provider, { value: Object.assign(Object.assign({}, props), { configs: Object.assign(Object.assign({}, configs), props.configs), currentUrl: props.currentUrl || currentUrl }) }, children));
};

function ClosePopupIcon({ className }) {
    return (React__default.createElement("div", null,
        React__default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", className: className },
            React__default.createElement("path", { d: "M18 6L6 18M18 18L6 6", stroke: "#3E3F58", strokeWidth: "1.3", strokeLinecap: "round" }))));
}

function HamburgerIcon({ siteType, enableSearch, className, style, }) {
    if (siteType === 'helloSites') {
        return (React__default.createElement("div", { className: "hamburger-container" },
            React__default.createElement("img", { "data-list-type": "Header", "data-content-type": "Navigation", "data-content-topic": "Hamburger", src: enableSearch
                    ? CommonGAssets.getAssetPath('hamburgerMenuNewWithSearch.svg')
                    : CommonGAssets.getAssetPath('hamburgerMenuNew.svg'), style: Object.assign({ width: '24px', height: '24px' }, style), alt: "home", className: className, loading: "lazy" })));
    }
    /** Marry Baby */
    return (React__default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", className: className },
        React__default.createElement("path", { d: "M3.35 15a.65.65 0 0 1 .65-.65h10a.65.65 0 1 1 0 1.3H4a.65.65 0 0 1-.65-.65m0-6A.65.65 0 0 1 4 8.35h16a.65.65 0 1 1 0 1.3H4A.65.65 0 0 1 3.35 9", fill: "#3E3F58" })));
}

const StyledMasterMenuContainer = styled.div `
  position: fixed;
  z-index: 201;
  top: calc(100% - 1px);
  width: 100%;
  height: calc(100vh - var(--header-bottom));
  overflow-x: hidden;
  overflow-y: auto;
  background: white;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  left: 0;
  .hhgcomp-navigation-popupwrapper-menuwrapper {
    position: unset;
  }
`;
styled.div `
  padding: 16px;
  padding-bottom: 12px;
  .fake-search-input {
    pointer-events: none;
    input {
      line-height: 20px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
  &[data-theme='marryBaby'] {
    input {
      background: ${theme.mbColors.lightGray};
      border-radius: 16px;
      border: none;
    }
  }
`;
const StyledWrapper = styled.div `
  display: block;
  overflow-y: auto;
  flex: 1;
  padding-bottom: 16px;
  &::-webkit-scrollbar {
    width: 0;
    display: none;
  }
`;
const StyleWrapperSearch = styled.div `
  padding: 0 16px;
`;

const Phone = (_a) => {
    var { size = 24, color = theme.colors.neutral600 } = _a, rest = __rest(_a, ["size", "color"]);
    return (React__default.createElement("svg", Object.assign({ width: size, height: size, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest),
        React__default.createElement("path", { d: "M6.088 18.75q-.63 0-1.068-.437a1.45 1.45 0 0 1-.438-1.07V2.757q0-.63.438-1.068a1.45 1.45 0 0 1 1.068-.438h7.82q.633 0 1.07.438.437.437.437 1.068v14.488q0 .63-.437 1.069a1.45 1.45 0 0 1-1.07.437zm3.91-1.859a.7.7 0 0 0 .522-.216.7.7 0 0 0 .216-.521.7.7 0 0 0-.216-.522.7.7 0 0 0-.521-.215.7.7 0 0 0-.522.215.7.7 0 0 0-.215.522.7.7 0 0 0 .215.521.7.7 0 0 0 .522.216m-4.166-3.333h8.333V4.792H5.832z", fill: color })));
};

const StyledItemGridLeft = styled.div `
  padding-right: 1rem;
  background: #ffffff;
  padding: 5px 15px;
  ${MediaQueries.mbUp} {
    border-right: 1px solid #e4e8ec;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`;
const StyledItem$6 = styled.a `
  padding: 10px 0;
  position: relative;

  display: flex;
  align-items: center;
  &[data-is-mobile-tool='true'] {
    align-items: flex-start;
    .name,
    .phone-icon {
      margin-top: 4px;
    }
  }
  text-decoration: none;
  color: ${theme.colors.gray800};
  * {
    pointer-events: none;
  }
  .name {
    font-size: 16px;
    font-weight: 400;
  }

  &[data-theme='marryBaby']:hover,
  &[data-theme='marryBaby'][data-active='true'] {
    p {
      color: ${theme.mbColors.pink};
    }
    .icon {
      background-color: ${theme.mbColors.lightPink};
    }
  }
  &[data-theme='helloSites']:hover,
  &[data-theme='helloSites'][data-active='true'] {
    p {
      color: ${theme.colors.primaryActive};
    }
  }
  a {
  }

  &[data-theme='marryBaby'] {
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      max-width: 40px;
      width: 100%;
      height: 40px;
      border-radius: 50%;
      background-color: ${theme.mbColors.lightGray};
      img {
        border-radius: 50%;
      }
    }
  }
`;
const StyledHeading$1 = styled.div `
  margin: 15px 0;
  ${MediaQueries.mbDown} {
    display: none;
  }
`;
const StyledIconNav = styled.div `
  display: flex;
  position: absolute;
  right: 0;
  ${MediaQueries.mbUp} {
    &.arrow-icon {
      display: none;
    }
  }
`;
const StyledItemAll = styled.div `
  display: flex;
  align-items: center;
  color: ${theme.colors.primaryBase};
  font-size: ${theme.sizes.fsParagraph4};
  font-weight: ${theme.sizes.fwBold};
  line-height: 24px;
  font-size: 14px;
  font-weight: 600;
  &[data-theme='marryBaby'] {
    color: ${theme.mbColors.pink};
  }
`;
const StyledImageWrapper = styled.div `
  display: flex;
  align-items: center;
  margin-left: 10px;
`;
const StyledViewMore$1 = styled.a `
  border: 1px solid ${theme.colors.primaryBase};
  &[data-theme='marryBaby'] {
    border: 1px solid ${theme.mbColors.pink};

    svg path {
      stroke: ${theme.mbColors.pink};
    }
  }
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 5px;
  margin-top: 20px;
  ${MediaQueries.mbDown} {
    display: none;
  }
`;

var styles$1 = {"menuIconWrapper":"wnUb-dV","menuButton":"cjbOxWe","itemNavButton":"-sx0jrx","scale":"EDlp5Zf"};

const ItemMenu = ({ item, menu }) => {
    const { containerRef, onButtonMouseDown, onClose } = useCSSFocusPopupHelper({
        allowBgScroll: true,
    });
    const isInit = useIsInit();
    if (!item.popupType && item.link) {
        return (React__default.createElement(NewWrapper, { isNew: item.isNew },
            React__default.createElement("a", { className: `hhgcomp-navigation-itemnav-headeritem ${!isInit ? `menu-handler-${item.id}` : ''}`, tabIndex: 0, href: item.link, "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": item.link },
                React__default.createElement("div", { "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": item.link, className: styles$1.menuButton }, item.name))));
    }
    return (React__default.createElement(NewWrapper, { isNew: item.isNew },
        React__default.createElement("div", { ref: containerRef, className: `hhgcomp-navigation-itemnav-headeritem ${!isInit ? `menu-handler-${item.id}` : ''}`, tabIndex: 0, key: item.id, "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": item.link },
            React__default.createElement("div", { "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": item.link, onMouseDown: onButtonMouseDown, className: styles$1.menuButton },
                item.name,
                item.popupType && (React__default.createElement(React__default.Fragment, null, (item === null || item === void 0 ? void 0 : item.icon) ? (React__default.createElement("div", { className: "wrapper-menu-icon" },
                    React__default.createElement("div", { className: "origin-icon" }, item.icon),
                    React__default.createElement("div", { className: "close-icon", onClick: onClose },
                        React__default.createElement(Close, { size: 16 })))) : (React__default.createElement("div", { className: styles$1.menuIconWrapper },
                    React__default.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none" },
                        React__default.createElement("path", { d: "M11.5 7.5L9 10L6.5 7.5", stroke: "#202135", strokeWidth: "1.33", strokeLinecap: "round", strokeLinejoin: "round" }))))))),
            React__default.isValidElement(menu)
                ? React__default.cloneElement(menu, {
                    onClose,
                })
                : null)));
};
const NewWrapper = ({ isNew, children, }) => {
    const { t } = useTranslations();
    if (isNew) {
        return (React__default.createElement(Indicator$1, { color: "green", label: t('home.navigator.menuItem.new'), size: 20, styles: {
                root: {
                    paddingRight: 10,
                },
            } }, children));
    }
    return React__default.createElement(React__default.Fragment, null, children);
};

const Categories = ({ hrefViewMore, titleBtnViewMore, UrlFE, onClosePopup, menuItems, headingTitle, activeItem, }) => {
    const { siteType } = useContext(NavigationContext);
    const { t } = useTranslations();
    const theme = useMantineTheme();
    return (React__default.createElement(StyledItemGridLeft, null,
        React__default.createElement("div", null,
            React__default.createElement(StyledHeading$1, null,
                React__default.createElement(Heading, { tag: siteType === 'marryBaby' ? 'h5' : 'h6', as: "p", fontWeight: "semibold" }, headingTitle)), menuItems === null || menuItems === void 0 ? void 0 :
            menuItems.slice(0, 6).map((item, index) => {
                const href = (item === null || item === void 0 ? void 0 : item.link)
                    ? (item === null || item === void 0 ? void 0 : item.link.startsWith('http'))
                        ? item === null || item === void 0 ? void 0 : item.link
                        : `${UrlFE}/${item === null || item === void 0 ? void 0 : item.link.split('/').filter(Boolean).join('/')}/`
                    : '/';
                return (React__default.createElement(StyledItem$6, Object.assign({ className: "iconMenu", "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": href, "data-is-heading-category": false, "data-active": item.id && item.id === activeItem, "data-is-mobile-tool": item.isMobileAppTool, href: href }, (!isInternalLink(href) && {
                    target: '_blank',
                }), { "data-theme": siteType, key: index, onClick: onClosePopup }),
                    React__default.createElement("div", { className: "icon" },
                        React__default.createElement("img", { loading: "lazy", alt: item.name, src: item.thumbnail || '/images/avatar.jpg', style: {
                                width: 32,
                                height: 32,
                                maxWidth: 32,
                                maxHeight: 32,
                                overflow: 'hidden',
                            } })),
                    React__default.createElement(NewWrapper, { isNew: item.isNew },
                        React__default.createElement("div", { style: {
                                padding: '0 0.4rem',
                                paddingRight: item.isNew ? 10 : 0,
                            } },
                            React__default.createElement("p", { className: "name" }, item.name),
                            item.isMobileAppTool && (React__default.createElement(Text, { size: "n1", color: theme.fn.primaryColor(), weight: "regular" }, t('home.calcWithApp'))))),
                    item.isMobileAppTool && (React__default.createElement(StyledIconNav, null,
                        React__default.createElement(Phone, { className: "phone-icon", size: 16 }))),
                    React__default.createElement(StyledIconNav, { className: "arrow-icon" },
                        React__default.createElement("img", { src: CommonGAssets.getAssetPath('chevronRight.svg'), style: { width: '16px', height: '16px' }, loading: "lazy" }))));
            })),
        titleBtnViewMore && (React__default.createElement(StyledViewMore$1, { "data-theme": siteType, style: { textDecoration: 'none' }, href: hrefViewMore, "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": hrefViewMore },
            React__default.createElement(StyledItemAll, { onClick: onClosePopup, "data-theme": siteType, "data-is-heading-category": false },
                titleBtnViewMore,
                React__default.createElement(StyledImageWrapper, null,
                    React__default.createElement("img", { className: "svg", src: siteType === 'marryBaby'
                            ? CommonGAssets.getAssetPath('chevronRightPink.svg')
                            : CommonGAssets.getAssetPath('chevronRightActive.svg'), style: { width: '16px', height: '16px' }, loading: "lazy" })))))));
};

const StyledContainerItems$5 = styled.div `
  display: grid;

  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 3.5rem;
  ${MediaQueries.tdDown} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const StyledImageCard$3 = styled.div `
  height: 152px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  overflow: hidden;
  border-radius: 4px;
  padding: 16px;
  width: 100%;

  .img-container {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
  }
  ${MediaQueries.tdDown} {
    margin-bottom: 0;
    padding: 0;
    height: 100%;
    position: unset;
    width: 150px;
  }
  ${MediaQueries.mbDown} {
    width: 80px;
  }
`;
const StyledImageCardInner = styled.div `
  background-color: #ffffff;
  border-radius: 4px;
  width: 100%;
  height: 100%;
`;
const StyledBtnView$2 = styled.div `
  display: flex;
  margin-top: 1rem;
  align-items: center;
  color: ${theme.colors.primaryBase};
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
  ${MediaQueries.tdDown} {
    display: none;
  }
`;
const StyledTitle$5 = styled.p `
  font-size: 16px;
  font-weight: 600;
  line-height: 1.6;
  color: ${theme.colors.gray800};
  ${MediaQueries.tdDown} {
    padding: 0;
  }
`;
const StyledDes$2 = styled.p `
  font-size: 14px;
  line-height: 1.6;
  font-weight: 400;
  color: ${theme.colors.gray600};
  height: 40px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: auto;
  ${MediaQueries.tdDown} {
    height: unset;
    padding: 0;
  }
`;
const StyledContentWrapper$2 = setDefaultClass(styled.div `
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    z-index: 1;
    ${MediaQueries.tdDown} {
      gap: 4px;
    }
  `, 'hhgcomp-navigation-menucareitem-contentwrapper');
const StyledItem$5 = styled.a `
  text-decoration: none;
  border-radius: 4px;
  background: ${theme.colors.white};
  position: relative;
  overflow: hidden;
  padding: 16px;
  display: flex;
  padding-top: 166px;
  * {
    pointer-events: none;
  }
  ${MediaQueries.tdUp} {
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06),
      0px 0px 1px rgba(0, 0, 0, 0.04);
    gap: 30px;
    flex-direction: column;
    a {
      display: flex;
      width: 100%;
    }
  }
  ${MediaQueries.tdDown} {
    padding-top: 16px;
    a {
      display: none;
    }
    grid-template-columns: 2fr 1fr;
    gap: 10px;
    display: grid;
    max-height: 110px;
    display: flex;
    flex-direction: row-reverse;
    > ${StyledContentWrapper$2.classSelector} {
      flex: 1;
    }
    img {
      width: 150px;
    }
  }
  ${MediaQueries.mbDown} {
    box-shadow: 0px 10px 16px rgba(0, 0, 0, 0.04),
      0px 2px 8px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04);
    display: flex;
    flex-direction: row-reverse;
    img {
      width: 80px;
      height: 80px;
    }
  }
  ${MediaQueries.tdOnly} {
    border: 1px solid ${theme.colors.neutral100};
  }
  .bg-svg {
    width: 100%;
    max-width: 245px;
    height: 100%;
    top: 0;
    right: -40px;
    position: absolute;
    display: inline-block;
  }
`;

const Item$4 = ({ item, index = 0 }) => {
    var _a;
    const { t } = useTranslations();
    const { locale, configs: { statics }, } = useContext(NavigationContext);
    if (!item)
        return null;
    const href = `${statics.CARE_URL_FE}/${(_a = LOCALIZED_SLUGS[locale]) === null || _a === void 0 ? void 0 : _a.HOSPITAL}/${item.slug}-${item.id}`;
    return (React__default.createElement(StyledItem$5, { key: item.id, href: href, "data-event-category": "Hamburger Navigation", "data-event-action": `Care Click ${index + 1}`, "data-event-label": href },
        React__default.createElement("img", { src: CommonGAssets.getAssetPath('navCareCardBg.svg'), alt: "", className: "bg-svg", loading: "lazy" }),
        React__default.createElement(StyledImageCard$3, null,
            React__default.createElement(StyledImageCardInner, null,
                React__default.createElement("img", { loading: "lazy", alt: item.name, src: item.logo || '/images/avatar.jpg' }))),
        React__default.createElement(StyledContentWrapper$2, null,
            React__default.createElement(StyledTitle$5, null, item.name),
            React__default.createElement(StyledDes$2, null, item.description),
            React__default.createElement(StyledBtnView$2, null,
                t('home.seeMore'),
                React__default.createElement("img", { src: CommonGAssets.getAssetPath('chevronRightActive.svg'), style: {
                        width: '16px',
                        height: '16px',
                        marginTop: '3px',
                        marginLeft: '5px',
                    }, loading: "lazy" })))));
};

const StyledContainerNoPosts = styled.div `
  padding: 16px;
  border-radius: 8px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  a {
    text-decoration: none;
  }

  .bg-svg {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  ${MediaQueries.mbDown} {
    display: block;
    .bg-svg {
      right: -24px;
      left: unset;
      top: 0;
      transform: rotateY(180deg);
    }
  }

  ${MediaQueries.mbUp} {
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr 3fr;
  }
`;
const StyledDescription = styled.div `
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${theme.colors.gray600};
  margin-bottom: 15px;
`;
const StyledTitle$4 = styled.div `
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  color: #000000;
  margin-bottom: 4px;
`;
const StyledContentLeft = styled.div `
  background: #fff;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
`;
const StyledLeft = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  ${MediaQueries.mbDown} {
    justify-content: end;
    min-height: 100px;
  }
`;

const SpotlightNoData = ({ title, link, description, cta, icon }) => {
    const { siteType } = useContext(NavigationContext);
    return (React__default.createElement(StyledContainerNoPosts, { "data-theme": siteType },
        React__default.createElement(StyledLeft, null,
            React__default.createElement("img", { src: siteType === 'marryBaby'
                    ? CommonGAssets.getAssetPath('navMBSpotlightBgNoData.svg')
                    : CommonGAssets.getAssetPath('navSpotlightBgNoData.svg'), alt: "", loading: "lazy", className: "bg-svg" }),
            React__default.createElement(StyledContentLeft, null, icon && React__default.createElement("img", { src: icon, width: 64, height: 64, loading: "lazy" }))),
        React__default.createElement("div", null,
            title && React__default.createElement(StyledTitle$4, null, title),
            description && React__default.createElement(StyledDescription, null, description),
            cta && (React__default.createElement("div", null,
                React__default.createElement("a", { href: link },
                    React__default.createElement(Button, { theme: siteType, className: "survey-contact-submit", size: "md" }, cta)))))));
};

const StyledItemGridRight = styled.div `
  margin-top: 10px;
  background: #ffffff;
  padding: 5px 15px;
  position: relative;
  ${MediaQueries.mbDown} {
    &:after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background-color: ${theme.colors.neutral100};
      content: '';
    }
  }
`;
const StyledHeading = styled.div `
  margin: 15px 0;
  display: flex;
`;
const StyledViewMore = styled.a `
  padding-left: 10px;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-weight: 400;
  font-size: 14px;
  color: ${theme.colors.primaryBase};
  &[data-theme='marryBaby'] {
    color: ${theme.mbColors.pink};
  }
  img {
    padding-left: 5px;
  }
  ${MediaQueries.mbDown} {
    margin-left: auto;
  }
`;

const Spotlights = ({ title, viewMore, children, link, dataEventAction = '', }) => {
    const { siteType } = useContext(NavigationContext);
    return (React__default.createElement(StyledItemGridRight, null,
        React__default.createElement(StyledHeading, null,
            React__default.createElement(Heading, { tag: siteType === 'marryBaby' ? 'h5' : 'h6', as: "p", fontWeight: "semibold" }, title),
            viewMore && (React__default.createElement(StyledViewMore, { "data-event-category": "Hamburger Navigation", "data-event-action": dataEventAction, "data-event-label": link, href: link, "data-theme": siteType },
                viewMore,
                React__default.createElement("img", { src: siteType === 'marryBaby'
                        ? CommonGAssets.getAssetPath('chevronRightPink.svg')
                        : CommonGAssets.getAssetPath('chevronRightActive.svg'), style: { width: '16px', height: '16px' }, loading: "lazy" })))),
        children));
};

const CareSpotlights = ({ spotlights = [], hrefViewMore }) => {
    const { t } = useTranslations();
    const { siteType } = useContext(NavigationContext);
    return (React__default.createElement(Spotlights, { title: t('home.navigator.menu.spotlightHospitals') }, spotlights.length !== 0 ? (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(StyledContainerItems$5, null, spotlights === null || spotlights === void 0 ? void 0 : spotlights.slice(0, 3).map((s, index) => (React__default.createElement(Item$4, { key: index, index: index, item: s })))),
        React__default.createElement("div", { style: {
                position: 'absolute',
                bottom: '6px',
                right: '1rem',
            } },
            React__default.createElement("a", { href: hrefViewMore },
                React__default.createElement(Button, { theme: siteType, className: "survey-contact-submit", size: "md" }, t('home.navigator.menu.care.homeButton')))))) : (React__default.createElement(SpotlightNoData, { title: t('home.navigator.menu.care.noDatas.title'), description: t('home.navigator.menu.care.noDatas.description'), link: hrefViewMore, cta: t('home.navigator.menu.care.homeButton'), icon: CommonGAssets.getAssetPath('community.svg') }))));
};

const StyledContainerItems$4 = styled.div `
  display: grid;

  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  ${MediaQueries.tdDown} {
    gap: 12px;
    grid-template-columns: 1fr;
  }
`;

const StyledItem$4 = styled.a `
  width: 100%;
  display: flex;
  align-items: center;
  text-decoration: none;
  * {
    pointer-events: none;
  }
`;
const StyledImageCard$2 = styled.div `
  border-radius: 5px;
  display: block;
  overflow: hidden;
  padding-top: 140%;
  width: 100%;
  position: relative;
  height: 0;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    top: 0;
    left: 0;
  }
  ${MediaQueries.tdDown} {
    width: 72px;
    padding-top: 100px;
  }
`;
const StyledTitle$3 = styled.p `
  font-size: 16px;
  font-weight: 400;
  padding: 4px 15px;
  line-height: 1.4;
  color: ${theme.colors.gray800};
  flex: 1;
  ${MediaQueries.tdUp} {
    display: none;
  }
`;

const Item$3 = ({ item, index = 0 }) => {
    if (!item)
        return null;
    return (React__default.createElement(StyledItem$4, { key: item.id, href: item.link, "data-event-category": "Hamburger Navigation", "data-event-action": `Spotlight Click ${index + 1}`, "data-event-label": item.link },
        React__default.createElement(StyledImageCard$2, null,
            React__default.createElement("img", { loading: "lazy", alt: item.title, src: item.banner || '/images/notFound-min-small.jpg' })),
        React__default.createElement(StyledTitle$3, null, item.title)));
};

const CategorySpotlights = ({ spotlightsList = [], hrefViewMore }) => {
    const { t } = useTranslations();
    const { configs: { statics }, } = useContext(NavigationContext);
    return (React__default.createElement(Spotlights, { title: t('home.navigator.menu.spotlights'), viewMore: t('home.navigator.menu.spotlights.seeAll'), link: hrefViewMore, dataEventAction: "Spotlight See More Click" }, spotlightsList.length !== 0 ? (React__default.createElement(StyledContainerItems$4, null, spotlightsList === null || spotlightsList === void 0 ? void 0 : spotlightsList.slice(0, 4).map((spotlight, index) => (React__default.createElement(Item$3, { key: index, index: index, item: {
            id: spotlight.id,
            link: statics.HOME_PAGE_URL + spotlight.permalink,
            title: spotlight.name,
            banner: spotlight.image,
        } }))))) : (React__default.createElement(SpotlightNoData, { title: t('home.navigator.menu.category.noDatas.title'), description: t('home.navigator.menu.category.noDatas.description'), link: hrefViewMore, cta: t('home.navigator.menu.category.noDatas.cta'), icon: CommonGAssets.getAssetPath('Spotlight.svg') }))));
};

const StyledContainerItems$3 = styled.div `
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 48px;
  ${MediaQueries.tdDown} {
    grid-template-columns: 1fr;
    grid-gap: 32px;
  }
  ${MediaQueries.mbDown} {
    grid-gap: 24px;
  }
`;

const StyledContent$1 = styled.div `
  padding: 5px;
  flex: 1;
`;
const StyledImage = styled.img `
  width: 88px;
  height: 88px;
  border-radius: 4px;
  object-fit: cover;
`;
const StyledName = styled.div `
  font-size: 12px;
  font-weight: 600;
  color: ${theme.colors.gray800};
  text-decoration: none;
  &[data-theme='marryBaby'] {
    font-weight: 400;
    letter-spacing: -0.2px;
  }
`;
const StyledCategory = styled.div `
  text-decoration: none;
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.primaryBase};
  &[data-theme='marryBaby'] {
    font-weight: 400;
    letter-spacing: -0.2px;
  }
`;
const StyledModifiedTime = styled.div `
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.gray600};
`;
const StyledDot = styled.div `
  font-size: 12px;
  font-weight: 400;
  color: ${theme.colors.gray600};
`;
const StyledItem$3 = styled.a `
  display: flex;
  gap: 10px;
  text-decoration: none;
  position: relative;
  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    border-top: 1px dashed ${theme.colors.neutral100};
    position: absolute;
    bottom: -24px;
    ${MediaQueries.tdOnly} {
      bottom: -16px;
    }
    ${MediaQueries.mbDown} {
      bottom: -12px;
    }
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
  ${MediaQueries.tdUp} {
    &:nth-last-child(2) {
      &::after {
        display: none;
      }
    }
  }
`;
const StyledInfoUser = styled.div `
  display: flex;
  gap: 10px;
  vertical-align: middle;
  align-items: center;
`;
const StyledTitle$2 = styled.div `
  margin-top: 8px;
  font-size: 16px;
  font-weight: 600;
  color: ${theme.colors.gray800};
  &[data-theme='marryBaby'] {
    margin-top: 12px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.2px;
  }
`;
const StyledInfo = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 5px;
`;
const StyledWrapInfo = styled.div `
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

dayjs.extend(relativeTime);
const Item$2 = ({ post, index = 0 }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { siteType, configs: { statics }, } = useContext(NavigationContext);
    if (!post)
        return null;
    const communityUrl = [statics.TOGETHER_URL_FE, (_a = post.community) === null || _a === void 0 ? void 0 : _a.slug].join('/');
    const postUrl = [communityUrl, post.slug].join('/');
    const time = post.createdAt;
    const cleanedTimeDate = time
        ? !isNaN(new Date(time).getTime())
            ? new Date(time)
            : null
        : null;
    const timeText = cleanedTimeDate ? dayjs(cleanedTimeDate).toNow(true) : time;
    return (React__default.createElement(StyledItem$3, { href: postUrl, "data-event-category": "Hamburger Navigation", "data-event-action": `Together Click ${index + 1}`, "data-event-label": postUrl },
        React__default.createElement(StyledContent$1, null,
            React__default.createElement(StyledInfoUser, null,
                React__default.createElement(UserAvatar, { avatar: (_b = post.author) === null || _b === void 0 ? void 0 : _b.avatar, username: ((_c = post.author) === null || _c === void 0 ? void 0 : _c.name) || ((_d = post.author) === null || _d === void 0 ? void 0 : _d.username) }),
                React__default.createElement(StyledWrapInfo, null,
                    React__default.createElement(StyledName, { "data-theme": siteType }, (_e = post.author) === null || _e === void 0 ? void 0 : _e.name),
                    React__default.createElement(StyledInfo, null,
                        React__default.createElement(StyledCategory, { "data-event-category": "Hamburger Navigation", "data-event-action": `Topic Click ${index + 1}`, "data-event-label": communityUrl, onClick: (e) => {
                                e.preventDefault();
                                location.href = communityUrl;
                            }, "data-theme": siteType }, (_f = post.community) === null || _f === void 0 ? void 0 : _f.name),
                        React__default.createElement(StyledDot, null, "\u2022"),
                        React__default.createElement(StyledModifiedTime, { "data-theme": siteType }, timeText)))),
            React__default.createElement(StyledTitle$2, null, post.title)),
        !!((_g = post.photos) === null || _g === void 0 ? void 0 : _g.length) && (React__default.createElement(StyledImage, { loading: "lazy", src: post.photos[0] }))));
};

const CommunitySpotlights = ({ spotlights = [] }) => {
    const { configs: { statics }, } = useContext(NavigationContext);
    const { t } = useTranslations();
    return (React__default.createElement(Spotlights, { title: t('home.navigator.menu.trendingPosts'), viewMore: t('home.navigator.menu.trendingPosts.seeMore'), link: normalizeLink(statics.TOGETHER_URL_FE), dataEventAction: "Together See More Click" }, spotlights.length !== 0 ? (React__default.createElement(StyledContainerItems$3, null, spotlights === null || spotlights === void 0 ? void 0 : spotlights.slice(0, 4).map((p, index) => (React__default.createElement(Item$2, { index: index, post: p, key: p.id }))))) : (React__default.createElement(SpotlightNoData, { title: t('home.navigator.menu.together.noPosts.title'), description: t('home.navigator.menu.together.noPosts.description'), link: `${statics.HOME_PAGE_URL}/community/`, cta: t('home.navigator.menu.together.noPosts.cta'), icon: CommonGAssets.getAssetPath('community.svg') }))));
};

const StyledContainerItems$2 = styled.div `
  display: grid;

  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-bottom: 3.5rem;
  ${MediaQueries.tdDown} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const StyledItem$2 = styled.a `
  text-decoration: none;
  display: flex;
  align-items: center;
`;

const Item$1 = ({ item, index = 0 }) => {
    if (!item)
        return null;
    return (React__default.createElement(StyledItem$2, { href: item.url, "data-event-category": "Hamburger Navigation", "data-event-action": `Care Click ${index + 1}`, "data-event-label": item.url },
        React__default.createElement("img", { loading: "lazy", alt: item.name, src: item.featuredImage || '/images/avatar.jpg', style: {
                width: '40px',
                height: '40px',
            } }),
        React__default.createElement(Text, { size: "p2", weight: "regular", style: {
                marginLeft: 16,
            } }, item.name),
        React__default.createElement("img", { src: CommonGAssets.getAssetPath('chevronRightActive.svg'), style: {
                width: '20px',
                height: '20px',
                marginLeft: 'auto',
            }, loading: "lazy" })));
};

const EcomSpotlights = ({ helpfulUrls = [], }) => {
    const { t } = useTranslations();
    // const { siteType } = useContext(NavigationContext)
    if (!helpfulUrls.length)
        return null;
    return (React__default.createElement(Spotlights, { title: t('home.navigator.menu.spotlightEcom') }, helpfulUrls.length !== 0 ? (React__default.createElement(StyledContainerItems$2, null, helpfulUrls === null || helpfulUrls === void 0 ? void 0 : helpfulUrls.slice(0, 5).map((s, index) => (React__default.createElement(Item$1, { key: index, index: index, item: s }))))) : (React__default.createElement(React__default.Fragment, null)
    // <SpotlightNoData
    //   title={t('home.navigator.menu.ecom.noDatas.title')}
    //   description={t('home.navigator.menu.ecom.noDatas.description')}
    //   link={hrefViewMore}
    //   cta={t('home.navigator.menu.ecom.homeButton')}
    //   icon={CommonGAssets.getAssetPath('ecom.svg')}
    // />
    )));
};

const StyledContainerItems$1 = styled.div `
  display: grid;

  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  ${MediaQueries.tdDown} {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

const AppIcon = (_a) => {
    var { size = 24, color = '#2D87F3' } = _a, rest = __rest(_a, ["size", "color"]);
    return (React__default.createElement("svg", Object.assign({ width: size, height: size, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest),
        React__default.createElement("rect", { width: "20", height: "20", rx: "4", fill: color }),
        React__default.createElement("path", { d: "M9.12 6.005c0-.088-.005-.181-.012-.27-.022-.611-.623-1.071-1.208-1.046-.69.04-.839 1.007-.248 1.297.09.047.115.088.105.172v5.048c.004.064-.016.096-.077.122-.63.274-.474 1.276.233 1.304.583.03 1.16-.453 1.195-1.044q.012-.135.013-.272c0-1.77.013-3.54 0-5.311m-3.093 5.34c-.109-.048-.144-.108-.132-.232V6.117c.009-.114.103-.108.176-.165.544-.357.313-1.249-.346-1.264h-.023c-.659 0-1.172.546-1.172 1.194q-.002 2.09.004 4.177l.003 1.396c0 .62.527 1.175 1.15 1.175.68 0 .989-.978.34-1.285m7.299-1.489a.623.623 0 1 1-1.247 0 .623.623 0 0 1 1.247 0", fill: "#fff" }),
        React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.927 9.821c0 1.338.925 2.46 2.162 2.743-.089 1.583-2.049 1.657-3.22 1.47a2.5 2.5 0 0 1-.716-.225 1.3 1.3 0 0 1-.614-.68c-.057-.142-.093-.293-.158-.431a.58.58 0 0 0-.674-.346.59.59 0 0 0-.462.603c.017.415.192.827.44 1.156.26.354.607.625 1.058.827.636.29 1.336.375 2.03.375.774 0 1.591-.132 2.267-.53.643-.38 1.25-.878 1.263-2.217a2.81 2.81 0 0 0 2.17-2.745c0-1.55-1.244-2.811-2.773-2.811S9.927 8.27 9.927 9.82m4.275 0c0 .841-.674 1.525-1.502 1.525a1.515 1.515 0 0 1-1.502-1.525c0-.84.674-1.525 1.502-1.525a1.516 1.516 0 0 1 1.502 1.525", fill: "#fff" })));
};

const StyledItem$1 = styled.a `
  text-decoration: none;
  border-radius: 4px;
  background: ${theme.colors.primary50};
  position: relative;
  overflow: hidden;
  display: flex;
  * {
    pointer-events: none;
  }
  .bg-svg {
    width: 245px;
    top: 0;
    right: 0;
    height: 100%;
    position: absolute;
    ${MediaQueries.tdDown} {
      top: calc(51% - 68px);
      right: -8px;
    }
  }
  padding: 180px 24px 16px;
  a {
    display: flex;
    width: 100%;
  }
  .phone-badge {
    position: absolute;
    top: 16px;
    left: 16px;
  }
  ${MediaQueries.tdDown} {
    padding-top: 16px;
    display: flex;
    align-items: center;
  }
  ${MediaQueries.mbDown} {
    .phone-badge {
      display: none;
    }
  }
`;
const StyledImageCard$1 = styled.div `
  width: 64px;
  height: 64px;
  background: white;
  position: absolute;
  right: 25px;
  top: 35px;
  z-index: 3;
  border-radius: 50%;
  img {
    position: absolute;
    width: 64px;
    height: 64px;
    top: 50%;
    left: 50%;
    display: block;
    transform: translate(-50%, -50%);
  }
  ${MediaQueries.tdDown} {
    position: relative;
    top: unset;
    right: unset;
  }
`;
const StyledBtnView$1 = styled.div `
  display: flex;
  align-items: center;
  gap: 4px;
  color: ${theme.colors.primaryBase};
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
`;
const StyledTitle$1 = styled.p `
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: ${theme.colors.gray800};
`;
const StyledDes$1 = styled.p `
  font-size: 14px;
  line-height: 1.4;
  font-weight: 400;
  color: ${theme.colors.gray600};
  height: 40px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: auto;
  ${MediaQueries.tdDown} {
    display: none;
  }
`;
const StyledContentWrapper$1 = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  z-index: 1;
  ${MediaQueries.tdUp} {
    gap: 8px;
  }
  ${MediaQueries.tdDown} {
    gap: 4px;
    flex: 1;
  }
`;

const Item = ({ item, index = 0 }) => {
    const { t } = useTranslations();
    const { configs: { statics }, } = useContext(NavigationContext);
    if (!item)
        return null;
    const link = item.link
        ? item.link.startsWith('http')
            ? item.link
            : `${statics.HOME_PAGE_URL}${item.link}`
        : undefined;
    return (React__default.createElement(StyledItem$1, { href: link, "data-event-category": "Hamburger Navigation", "data-event-action": `Engage Click ${index + 1}`, "data-event-label": link },
        item.isMobileAppTool && React__default.createElement(Phone, { size: 20, className: "phone-badge" }),
        React__default.createElement("img", { src: CommonGAssets.getAssetPath('navToolCardBg.svg'), alt: "", loading: "lazy", className: "bg-svg" }),
        React__default.createElement(StyledContentWrapper$1, null,
            React__default.createElement(StyledTitle$1, null, item.title),
            React__default.createElement(StyledDes$1, null, item.subtitle),
            React__default.createElement(StyledBtnView$1, null, item.isMobileAppTool ? (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(AppIcon, { size: 16 }),
                t('home.calcWithApp'))) : (React__default.createElement(React__default.Fragment, null,
                t('home.seeMore'),
                React__default.createElement(ArrowRight, { size: 18, useCurrentColor: true }))))),
        React__default.createElement(StyledImageCard$1, null,
            React__default.createElement("img", { loading: "lazy", alt: item.title, src: item.icon || '/images/avatar.jpg' }))));
};

const StyledItem = styled.a `
  text-decoration: none;
  border-radius: 12px;

  position: relative;
  overflow: hidden;
  display: flex;
  * {
    pointer-events: none;
  }
  .bg-svg {
    top: 0;
    left: 0;
    position: absolute;
  }

  .dot-svg {
    width: 40px;
    height: 30px;
    top: 36px;
    left: 16px;
    position: absolute;
    stroke-width: 0;
  }

  &[data-color='pink'] {
    background: ${theme.mbColors.tonePink};
    .bg-svg {
      fill: ${theme.mbColors.peach};
    }
  }
  &[data-color='orange'] {
    background: ${theme.mbColors.toneYellow};
    .bg-svg {
      fill: ${theme.mbColors.orange};
    }
  }
  &[data-color='green'] {
    background: ${theme.mbColors.toneGreen};
    .bg-svg {
      fill: ${theme.mbColors.mint};
    }
  }

  padding: 180px 24px 16px;
  a {
    display: flex;
    width: 100%;
  }
  ${MediaQueries.tdDown} {
    padding-top: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
  }
  ${MediaQueries.mbDown} {
    padding-top: 0;
    padding-left: 80px;
    height: 96px;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    .dot-svg {
      top: 22px;
      left: 16px;
    }
  }
  ${MediaQueries.tdUp} {
    min-height: 296px;
  }
  .mobile-only {
    ${MediaQueries.tdUp} {
      display: none;
    }
  }
  .desktop-only {
    ${MediaQueries.tdDown} {
      display: none;
    }
  }
`;
const StyledImageCard = styled.div `
  width: 48px;
  height: 48px;
  background: white;
  position: absolute;
  right: 25px;
  top: 35px;
  z-index: 3;
  border-radius: 50%;
  img {
    position: absolute;
    width: 36px;
    height: 36px;
    top: 50%;
    left: 50%;
    display: block;
    transform: translate(-50%, -50%);
  }
  ${MediaQueries.tdDown} {
    position: relative;
    top: unset;
    right: unset;
  }
  ${MediaQueries.mbDown} {
    position: absolute;
    left: 32px;
    top: 28px;
  }
`;
const StyledBtnView = styled.div `
  display: flex;
  align-items: center;
  background: white;
  font-weight: 400;
  font-size: 14px;
  text-decoration: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;

  svg path {
    fill: ${theme.mbColors.gray};
  }

  ${MediaQueries.tdDown} {
    background: none;
    width: 100%;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: ${theme.mbColors.pink};
    padding-left: 16px;
  }
`;
const StyledTitle = styled.p `
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: ${theme.colors.gray800};
`;
const StyledDes = styled.p `
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: -0.2px;
  color: ${theme.colors.gray600};
  height: 54px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  margin-bottom: auto;
  ${MediaQueries.tdDown} {
    display: none;
  }
`;
const StyledContentWrapper = styled.div `
  display: flex;
  flex: 1;
  z-index: 1;
  align-items: flex-end;
  justify-content: flex-end;
  ${MediaQueries.tdUp} {
    gap: 8px;
    flex-direction: row;
  }

  ${MediaQueries.tdDown} {
    align-items: flex-start;
    justify-content: flex-start;
    gap: 4px;
  }
`;
const StyledContent = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  z-index: 1;
  ${MediaQueries.tdUp} {
    gap: 8px;
  }
  ${MediaQueries.tdDown} {
    gap: 4px;
    flex: 1;
    padding-left: 16px;
  }
`;
const StyledWrapName = styled.div `
  display: flex;
  flex-direction: row;
  flex: 1;
  z-index: 1;
  ${MediaQueries.tdUp} {
    gap: 8px;
    justify-content: flex-end;
    align-items: flex-end;
  }
  ${MediaQueries.tdDown} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

const ItemMarryBaby = ({ item, index = 0, color }) => {
    const { t } = useTranslations();
    const { configs: { statics }, } = useContext(NavigationContext);
    if (!item)
        return null;
    const link = item.link
        ? item.link.startsWith('http')
            ? item.link
            : `${statics.HOME_PAGE_URL}${item.link}`
        : undefined;
    const renderIcon = () => (React__default.createElement(StyledImageCard, null,
        React__default.createElement("img", { loading: "lazy", alt: item.title, src: item.icon || '/images/avatar.jpg' })));
    const renderName = () => (React__default.createElement(StyledWrapName, null,
        React__default.createElement(StyledContent, null,
            React__default.createElement(StyledTitle, null, item.title),
            React__default.createElement(StyledDes, null, item.subtitle)),
        React__default.createElement(StyledBtnView, null,
            React__default.createElement("div", { className: "mobile-only" }, t('home.seeMore')),
            React__default.createElement("img", { src: CommonGAssets.getAssetPath('arrowRightGray.svg'), style: {
                    width: '12px',
                    height: '12px',
                    marginTop: '2px',
                    marginLeft: '5px',
                }, loading: "lazy" }))));
    return (React__default.createElement(StyledItem, { href: link, "data-event-category": "Hamburger Navigation", "data-event-action": `Engage Click ${index + 1}`, "data-event-label": link, "data-color": color },
        React__default.createElement("svg", { className: "bg-svg", width: "74", height: "121", viewBox: "0 0 74 121", fill: "none" },
            React__default.createElement("path", { d: "M58.5713 53.428C40.6466 70.0213 12.9929 71.0875 -7.00506 84.9856C-24.9277 97.4005 -38.3893 120.472 -60.213 120.346C-73.3615 120.271 -84.9289 110.925 -91.9303 99.8138C-101.443 84.7327 -103.994 64.0482 -93.916 49.3276C-81.8133 31.6505 -56.6933 28.1101 -41.7246 12.7895C-35.4351 6.35117 -31.2212 -1.90115 -24.8564 -8.25051C-7.17639 -25.9054 34.9604 -29.7543 56.852 -16.9562C80.9056 -2.89888 77.046 36.3304 58.5713 53.428Z", strokeWidth: "0" })),
        React__default.createElement("img", { src: CommonGAssets.getAssetPath('navMBCardDotBg.svg'), className: "dot-svg", loading: "lazy", alt: "" }),
        React__default.createElement(StyledContentWrapper, null,
            React__default.createElement("div", { className: "mobile-only" }, renderIcon()),
            React__default.createElement("div", { className: "desktop-only" }, renderName())),
        React__default.createElement("div", { className: "mobile-only" }, renderName()),
        React__default.createElement("div", { className: "desktop-only" }, renderIcon())));
};

const ToolSpotlights = ({ hrefViewMore, spotlightHealthTools = [] }) => {
    const { t } = useTranslations();
    const marryBabyCardColor = ['pink', 'orange', 'green'];
    const { siteType } = useContext(NavigationContext);
    return (React__default.createElement(Spotlights, { title: t('home.navigator.menu.spotlightTools') },
        spotlightHealthTools.length !== 0 && (React__default.createElement(StyledContainerItems$1, null, spotlightHealthTools === null || spotlightHealthTools === void 0 ? void 0 : spotlightHealthTools.slice(0, 3).map((item, index) => siteType === 'marryBaby' ? (React__default.createElement(ItemMarryBaby, { key: index, index: index, item: item, color: marryBabyCardColor[index] })) : (React__default.createElement(Item, { key: index, index: index, item: item }))))),
        spotlightHealthTools.length === 0 && (React__default.createElement(SpotlightNoData, { title: t('home.navigator.menu.healthTools.noDatas.title'), description: t('home.navigator.menu.healthTools.noDatas.description'), link: hrefViewMore, cta: t('home.navigator.menu.healthTools.noDatas.cta'), icon: CommonGAssets.getAssetPath('community.svg') }))));
};

const StyledContainerItems = styled.div `
  display: grid;

  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  ${MediaQueries.tdDown} {
    gap: 12px;
    grid-template-columns: 1fr;
  }
`;

const VideoSpotlights = ({ spotlightsList = [], layout = 'default', }) => {
    const { t } = useTranslations();
    const { configs: { statics }, } = useContext(NavigationContext);
    return (React__default.createElement(Spotlights, { title: t('home.navigator.menu.lastestVideos') }, spotlightsList.length !== 0 ? (React__default.createElement(StyledContainerItems, null, spotlightsList === null || spotlightsList === void 0 ? void 0 : spotlightsList.slice(0, 4).map((video, index) => (React__default.createElement(VideoItem, { key: index, data: Object.assign(Object.assign({}, video), { type: VideoType.SHORTS }), layout: layout === 'default' ? 'overlay' : 'horizon', redirectToLandingPage: true, dataEventCategory: "Hamburger Navigation", dataEventAction: `Video Click ${index + 1}` }))))) : (React__default.createElement(SpotlightNoData, { title: t('home.navigator.menu.category.noDatas.title'), description: t('home.navigator.menu.category.noDatas.description'), link: `${statics.VIDEO_URL_FE}/`, cta: t('home.navigator.menu.category.noDatas.cta'), icon: CommonGAssets.getAssetPath('Spotlight.svg') }))));
};

const MenuServiceList = ({ closePopup, menuItems = [], projectType, isHomepage = false, }) => {
    var _a, _b;
    const { siteType, ssrMenuContent: { categories, healthTools, care, together, ecom, videos }, activeMenuService, configs: { statics }, locale, } = useContext(NavigationContext);
    const { t } = useTranslations();
    return (React__default.createElement(StyledMasterMenuContainer, { id: 'categories-menu' },
        !isHomepage && (React__default.createElement(StyleWrapperSearch, null,
            React__default.createElement(NavigtionSearch, { siteType: siteType, projectType: projectType, isMobile: false, isRedirectSearchPage: true }))),
        React__default.createElement(StyledWrapper, null,
            React__default.createElement(Categories, { UrlFE: statics.HOME_PAGE_URL, titleBtnViewMore: t('home.navigator.menuItem.allCategories'), menuItems: menuItems, headingTitle: t('home.navigator.menuItem.healthCategories'), onClosePopup: closePopup, activeItem: activeMenuService }),
            activeMenuService === 'categories' && (React__default.createElement(CategorySpotlights, { spotlightsList: (categories === null || categories === void 0 ? void 0 : categories.spotlights) || [], hrefViewMore: `${statics.HOME_PAGE_URL}${locale === 'tl-PH' ? '/fil' : ''}/spotlight/` })),
            activeMenuService === 'tools' && (React__default.createElement(ToolSpotlights, { spotlightHealthTools: healthTools === null || healthTools === void 0 ? void 0 : healthTools.spotlights, hrefViewMore: `${statics.HOME_PAGE_URL}${locale === 'tl-PH' ? '/fil' : ''}${((_a = STATIC_PAGES[locale]) === null || _a === void 0 ? void 0 : _a.HEALTH_TOOLS) || ''}` })),
            activeMenuService === 'care' && (React__default.createElement(CareSpotlights, { spotlights: care === null || care === void 0 ? void 0 : care.spotlights, hrefViewMore: `${statics.CARE_URL_FE}/${(_b = LOCALIZED_SLUGS[locale]) === null || _b === void 0 ? void 0 : _b.SPECIALTIES}` })),
            activeMenuService === 'together' && (React__default.createElement(CommunitySpotlights, { spotlights: together === null || together === void 0 ? void 0 : together.spotlights })),
            activeMenuService === 'ecom' && (React__default.createElement(EcomSpotlights, { helpfulUrls: ecom === null || ecom === void 0 ? void 0 : ecom.helpfulUrls })),
            activeMenuService === 'video' && (React__default.createElement(VideoSpotlights, { spotlightsList: videos === null || videos === void 0 ? void 0 : videos.spotlights, layout: "stack" })))));
};

const HamburgerMenu = ({ menuItems, isHomepage, projectType }) => {
    const { siteType } = useContext(NavigationContext);
    const { containerRef, onContainerFocus, onContainerBlur, onButtonMouseDown, onClose, } = useCSSFocusPopupHelper();
    return (React__default.createElement(DisplayWrapper, { mediaQueryKey: "mbDown" },
        React__default.createElement("header", { className: styles$2.menuContainer },
            React__default.createElement("div", { className: styles$2.menuIcon, ref: containerRef, role: "button", tabIndex: 0, onBlur: onContainerBlur, onFocus: onContainerFocus },
                React__default.createElement("div", { className: styles$2.menuIconWrapper, onMouseDown: onButtonMouseDown, "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": "Hamburger Navigation URL" },
                    React__default.createElement(ClosePopupIcon, { className: "mobile-close-icon" }),
                    React__default.createElement(HamburgerIcon, { siteType: siteType, enableSearch: false, className: "mobile-hamburger-icon" })),
                React__default.createElement(MenuServiceList, { menuItems: menuItems, isHomepage: isHomepage, projectType: projectType, closePopup: onClose })))));
};

const TOGETHER_PATHS = {
    COMMUNITIES: 'community?website_url={websiteUrl}',
    MENU_TOPIC: 'topic?community_id={communityId}&website_url={websiteUrl}',
    GET_USER_POSTS: 'profile/posts?website_url={websiteUrl}',
};
const Z_INDEX = {
    adBlock: 48,
    headerContainerHome: 99,
    headerContainerPopup: 300,
    headerContainerPopupSUbLevel: 400,
    menuCategoryPopupWrapper: 200,
    menuCategoryPopupContainer: 210,
    menuSearchInputPopup: 5,
    menuSearchInputDisplayIcon: 6,
    menuSearchPopup: 300,
    homeSearchComponent: 200,
};

const StyledHeaderWrapper = styled.div `
  z-index: 201;
  width: 100%;
  align-items: center;

  background-color: ${theme.colors.white};

  transition: height 0.3s, transform 0.3s;

  &[data-site-type='helloSites'] {
    border-bottom: 1px solid ${theme.colors.neutral100};
  }
  &[data-sponsored='true'] {
    border-bottom: none;
  }
  &[data-marry-baby-tone='pink'] {
    background-color: ${theme.mbColors.lightPink};
  }

  ${MediaQueries.mbUp} {
    &[data-sitewide-banner-shown='true'][data-collapsed='true'] {
      transform: translateY(-64px);
    }
  }
  ${MediaQueries.mbDown} {
    &[data-site-type='marryBaby'] {
      border-bottom: none;
    }

    &[data-fixed-bar='true'] {
      position: fixed;
      transform: translateY(0);
    }

    &[data-fixed-bar='false'] {
      position: absolute;
    }

    &[data-collapsed='true'] {
      transform: translateY(-100%);
      transition: transform 0.5s;
    }
    &[data-collapsed='false'] {
      transform: translateY(0);
      transition: transform 0.5s;
    }

    .top-bar-header {
      line-height: normal;
    }

    &[data-header-type='home'] {
      z-index: ${Z_INDEX.headerContainerHome};
    }

    &[data-is-displayed='false'] {
      //display: none;
      visibility: hidden;
    }
  }

  .marry-baby {
    input {
      background: ${theme.mbColors.lightGray};
      border-radius: 16px;
      border: none;
    }
    max-width: 172px;
  }
  &[data-site-type='marryBaby'] {
    .close-btn {
      top: 16px;
      right: 16px;
    }
  }
`;
const StyledHeader = styled.div `
  display: flex;
  height: 100%;
  align-items: center;

  justify-content: space-between;
  padding: 0 2rem;
  height: 56px;
  ${MediaQueries.pcDown} {
    padding: 0 1rem;
  }

  ${MediaQueries.mbDown} {
    position: relative;
    height: 56px;
    background: white;
    gap: 2px;
  }

  &[data-site-type='marryBaby'] {
    width: 100%;
    margin: 0 auto;
    padding: 0 16px;
    ${MediaQueries.tdUp} {
      max-width: 1064px;
    }
  }
`;
const StyledLeftGroup = styled.div `
  display: flex;
  align-items: center;
  height: 100%;
  gap: 24px;
  ${MediaQueries.pcDown} {
    flex-shrink: 0;
    gap: 12px;
    &[data-site-type='marryBaby'] {
      gap: 24px;
    }
  }
`;
const StyledRightGroup = styled.div `
  display: flex;
  align-items: center;
  height: 100%;
  flex-shrink: 0;
  ${MediaQueries.tdDown} {
    flex-shrink: 0.6;
    gap: 8px;
  }
  .hhgcomp-navigation-itemnav-headeritem {
    gap: 2px;
    ${MediaQueries.pcUp} {
      padding: 0 10px;
    }
    ${MediaQueries.pcDown} {
      padding: 0 6px;
    }
    ${MediaQueries.mbDown} {
      display: none;
    }
    a {
      text-decoration: none;
    }
  }
`;
styled.div `
  .fake-search-input {
    pointer-events: none;
    input {
      line-height: 20px;
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
`;
const StyledProfileNavGroup = styled.div `
  margin-left: 16px;
  display: flex;
  gap: 12px;
  align-items: center;
  flex-shrink: 0;
  ${MediaQueries.pcDown} {
    margin-left: 8px;
    gap: 8px;
  }
  ${MediaQueries.mbDown} {
    margin-left: 0;
    gap: 8px;
  }

  .ai-doctor-nav-item {
    .ai-doctor-btn {
      border-radius: 28px;
      border: 1px solid ${theme.colors.neutral200};
    }
  }
`;
const StyledWrapMenuItems = styled.div `
  display: flex;
  align-items: center;
  height: 100%;
  &[data-site-type='marryBaby'] {
    gap: 26px;
  }

  .hamburger-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
const StyleWrapperNavigtionSearch = styled.div `
  padding: 0 16px 6px;
`;
const StyleButtonAiChat = styled(Button$1) `
  border-radius: 28px;
  border: 1px solid ${theme.colors.neutral200};
  &.ai-doctor-btn {
    pointer-events: none !important;
    * {
      pointer-events: none !important;
    }
  }
  ${MediaQueries.mbDown} {
    padding: 0px 12px 0px 10px;
    height: 36px;
    color: ${theme.colors.gray900};
    font-size: 13px;
    font-weight: 500;
    line-height: 22px;
  }
`;

const StyleInput = styled(Input) `
  .mantine-Input-input {
    border-radius: 40px;
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.blue200};

    &:focus {
      border: 1px solid ${theme.colors.primaryBase};
    }
  }

  .close-icon-wrapper {
    display: flex;
    background-color: ${theme.colors.gray400};
    border-radius: 100%;
    cursor: pointer;

    svg {
      pointer-events: none;
    }
  }

  .search-icon-btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const SearchInput = ({ id, isMobile = false, isHomepage = false, projectType, isRedirectSearchPage = false, }) => {
    const { locale, configs: { statics }, siteType, } = useContext(NavigationContext);
    const [keyword, setKeyword] = useState('');
    const [eventCategoryTracking, setEventCategoryTracking] = useState('Search From Another Page');
    const { t } = useTranslations();
    const goToSearchPage = (searchValue = '') => {
        let sourceParam = '';
        if (projectType === 'together') {
            sourceParam = 'community';
        }
        if (projectType === 'discover') {
            if (window.location.pathname.startsWith('/health-tools/')) {
                sourceParam = 'health-tools';
            }
            else {
                sourceParam = projectType;
            }
        }
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('source', sourceParam);
        searchParams.set('s', searchValue);
        searchParams.delete('page');
        window.location.href = `${statics.HOME_PAGE_URL}/search/?${searchParams.toString()}`;
    };
    useEffect(() => {
        if (typeof window !== 'undefined') {
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);
            const searchValue = params.get('s');
            if (projectType === 'discover' &&
                window.location.pathname.startsWith('/search/')) {
                setEventCategoryTracking('Search Page');
            }
            setKeyword(searchValue);
        }
    }, []);
    return isMobile && !isHomepage ? (React__default.createElement(Button$1, { variant: "tertiary", style: {
            padding: '6px',
        }, size: "sm", onClick: () => {
            goToSearchPage('');
        } },
        React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", style: {
                verticalAlign: 'bottom',
            } },
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.3097 9.06111C3.3097 5.88483 5.88458 3.30994 9.06087 3.30994C12.2372 3.30994 14.812 5.88483 14.812 9.06111C14.812 12.2374 12.2372 14.8123 9.06087 14.8123C5.88458 14.8123 3.3097 12.2374 3.3097 9.06111ZM9.06087 1.66675C4.97707 1.66675 1.6665 4.97732 1.6665 9.06111C1.6665 13.1449 4.97707 16.4555 9.06087 16.4555C10.8067 16.4555 12.4112 15.8505 13.6761 14.8387L16.9305 18.0931C17.2514 18.4139 17.7716 18.4139 18.0924 18.0931C18.4133 17.7722 18.4133 17.252 18.0924 16.9312L14.8381 13.6768C15.8501 12.4118 16.4552 10.8071 16.4552 9.06111C16.4552 4.97732 13.1447 1.66675 9.06087 1.66675Z", fill: "#8C8C8C" })))) : (React__default.createElement(StyleInput, { className: "fake-search-input", name: 'search-input-menu-service' + id, size: "md", "data-event-category": eventCategoryTracking, "data-event-action": "Search", "data-event-label": keyword, placeholder: siteType === 'marryBaby'
            ? t('navigation.search.input.placeholder')
            : t('home.search', {
                site: LOCALE_SPECS[locale || 'en-PH']
                    ? LOCALE_SPECS[locale || 'en-PH'].SITE_NAME
                    : '',
            }), onChange: setKeyword, value: keyword, onKeyDown: (e) => e.key === 'Enter' &&
            goToSearchPage(e.target.value), type: "search", onFocus: (e) => {
            e.preventDefault();
            if ((isMobile && isHomepage) || isRedirectSearchPage) {
                goToSearchPage('');
            }
        }, rightSection: keyword ? (React__default.createElement("div", { className: "close-icon-wrapper", onClick: () => setKeyword(''), "data-event-category": "Search Page", "data-event-action": "Delete Search" },
            React__default.createElement(Close, { size: 17, color: theme.colors.white }))) : (''), icon: React__default.createElement("a", { "data-event-category": "Search Button", "data-event-action": "Click", className: "search-icon-btn", onClick: () => {
                if ((isMobile && isHomepage) || isRedirectSearchPage) {
                    goToSearchPage('');
                }
            } },
            React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", style: {
                    verticalAlign: 'bottom',
                } },
                React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.3097 9.06111C3.3097 5.88483 5.88458 3.30994 9.06087 3.30994C12.2372 3.30994 14.812 5.88483 14.812 9.06111C14.812 12.2374 12.2372 14.8123 9.06087 14.8123C5.88458 14.8123 3.3097 12.2374 3.3097 9.06111ZM9.06087 1.66675C4.97707 1.66675 1.6665 4.97732 1.6665 9.06111C1.6665 13.1449 4.97707 16.4555 9.06087 16.4555C10.8067 16.4555 12.4112 15.8505 13.6761 14.8387L16.9305 18.0931C17.2514 18.4139 17.7716 18.4139 18.0924 18.0931C18.4133 17.7722 18.4133 17.252 18.0924 16.9312L14.8381 13.6768C15.8501 12.4118 16.4552 10.8071 16.4552 9.06111C16.4552 4.97732 13.1447 1.66675 9.06087 1.66675Z", fill: "#8C8C8C" }))) }));
};

const formatSponsor = (sponsor) => {
    if (!sponsor)
        return {};
    return {
        title: sponsor.title,
        logo: sponsor.logo,
        link: sponsor.link,
    };
};
const formatReviewedCategory = (data) => {
    return {
        postTitle: data.post_title,
        permalink: data.permalink,
    };
};
const formatFaqsCategory = (data) => {
    return {
        title: data.title,
        content: data.content,
    };
};
const formatCategory = (category) => {
    var _a, _b;
    if (!category)
        return {};
    return {
        termId: category.term_id || null,
        sponsor: category.sponsor ? formatSponsor(category.sponsor) : null,
        isSponsored: category.is_sponsored || null,
        categoryName: category.cat_name || category.name || null,
        name: category.name || null,
        iconUrl: category.icon || '',
        slugName: category.category_nicename || null,
        description: category.description || null,
        featureImage: category.thumbnail || category.image || null,
        displayName: category.name || null,
        parent: category.parent || null,
        permalink: category.permalink || null,
        slug: category.slug || null,
        childCates: ((_a = category.child_cates) === null || _a === void 0 ? void 0 : _a.map((childCate) => {
            return formatCategory(childCate);
        })) || [],
        thumnailColor: category.thumnail_color ||
            ['#FFEAF1', '#E0E9FB', '#FFF9EB', '#F2FCF7', '#F3F3F3'][(Math.random() * 5) | 0],
        colorFeatureImage: category.color_feature_image || null,
        imageColor: category.image_color || null,
        textColor: category.text_color || null,
        catParent: ((_b = category.cat_parent) === null || _b === void 0 ? void 0 : _b.name)
            ? {
                name: category.cat_parent.name,
                permalink: category.cat_parent.permalink,
            }
            : {},
        metaTag: category.meta_tag || '',
        reviewedBy: category.reviewed_by
            ? formatReviewedCategory(category.reviewed_by)
            : null,
        reviewedDate: category.reviewed_date || '',
        faqs: category.faqs
            ? category.faqs.map((faq) => formatFaqsCategory(faq))
            : null,
        customizedUrl: category.customized_url || null,
    };
};
const formatHealthTool = (healthTool) => {
    var _a, _b;
    if (!healthTool)
        return {};
    const isBot = (_a = healthTool.link) === null || _a === void 0 ? void 0 : _a.includes('/bot/');
    const hasFilPrefix = (_b = healthTool.link) === null || _b === void 0 ? void 0 : _b.startsWith('/fil/');
    const link = healthTool.link
        ? healthTool.link.startsWith('http')
            ? healthTool.link
            : isBot
                ? healthTool.link
                : hasFilPrefix
                    ? healthTool.link
                        .replace('/health-tools/', '/')
                        .replace('/fil/', '/fil/health-tools/')
                    : `/health-tools${healthTool.link.replace('/health-tools/', '/')}`
        : undefined;
    return {
        icon: healthTool.icon,
        link,
        subtitle: healthTool.subtitle,
        title: healthTool.title,
        isMobileAppTool: healthTool.is_mobile_app_tool,
    };
};
const formatSpecialties = (specialties) => {
    var _a, _b, _c, _d, _e;
    if (!specialties || !(specialties === null || specialties === void 0 ? void 0 : specialties.object_id))
        return {};
    return {
        thumbnail: ((_a = specialties === null || specialties === void 0 ? void 0 : specialties.object_id) === null || _a === void 0 ? void 0 : _a.logo) || '',
        link: ((_b = specialties === null || specialties === void 0 ? void 0 : specialties.object_id) === null || _b === void 0 ? void 0 : _b.slug) || '',
        subtitle: ((_c = specialties.object_id) === null || _c === void 0 ? void 0 : _c.name) || '',
        name: ((_d = specialties.object_id) === null || _d === void 0 ? void 0 : _d.name) || '',
        slug: ((_e = specialties.object_id) === null || _e === void 0 ? void 0 : _e.slug) || '',
    };
};
const formatHospital = (hospital) => {
    var _a, _b, _c, _d, _e;
    if (!hospital || !(hospital === null || hospital === void 0 ? void 0 : hospital.object_id))
        return {};
    return {
        id: (_a = hospital.object_id) === null || _a === void 0 ? void 0 : _a.id,
        name: ((_b = hospital.object_id) === null || _b === void 0 ? void 0 : _b.name) || '',
        logo: ((_c = hospital === null || hospital === void 0 ? void 0 : hospital.object_id) === null || _c === void 0 ? void 0 : _c.logo) || '',
        description: ((_d = hospital.object_id) === null || _d === void 0 ? void 0 : _d.description) || '',
        slug: ((_e = hospital.object_id) === null || _e === void 0 ? void 0 : _e.slug) || '',
    };
};
const getTogetherUserPostsApiPath = (locale, isMarryBaby, apiDomain, params) => {
    const apiUrl = apiDomain || `https://together.hellohealthgroup.com/`;
    return (apiUrl +
        'api/v1/' +
        formatString(TOGETHER_PATHS.GET_USER_POSTS, Object.assign(Object.assign({}, params), { websiteUrl: isMarryBaby
                ? 'https://marrybaby.vn'
                : `https://${domainLocales[locale]}` })));
};
const getCareSearchUrl = ({ type, specialtySlug, locale, }) => {
    var _a, _b;
    return `${(_a = LOCALIZED_SLUGS[locale]) === null || _a === void 0 ? void 0 : _a.ALL}/${((_b = LOCALIZED_SLUGS[locale]) === null || _b === void 0 ? void 0 : _b[type]) || 'doctor'}/${specialtySlug !== null && specialtySlug !== void 0 ? specialtySlug : ''}`;
};
const formatSpotlightsList = (spotlight) => {
    if (!spotlight)
        return {};
    return {
        id: spotlight.ID,
        name: spotlight.name,
        permalink: spotlight.permalink,
        image: (spotlight === null || spotlight === void 0 ? void 0 : spotlight.small_banner) || (spotlight === null || spotlight === void 0 ? void 0 : spotlight.image) || '',
        imageMedium: (spotlight === null || spotlight === void 0 ? void 0 : spotlight.image_medium) || null,
        imageThumbnail: (spotlight === null || spotlight === void 0 ? void 0 : spotlight.image_thumbnail) || null,
        startDate: spotlight === null || spotlight === void 0 ? void 0 : spotlight.start_date,
        endDate: spotlight === null || spotlight === void 0 ? void 0 : spotlight.end_date,
    };
};
const checkAvailableSpotlight = (spotlight) => {
    const today = new Date();
    if (spotlight === null || spotlight === void 0 ? void 0 : spotlight.startDate) {
        const startDate = new Date(spotlight.startDate);
        if (today.getTime() < startDate.getTime())
            return false;
    }
    if (spotlight === null || spotlight === void 0 ? void 0 : spotlight.endDate) {
        const endDate = new Date(spotlight.endDate);
        if (today.getTime() > endDate.getTime())
            return false;
    }
    return true;
};
const formatVideoItem = (data) => {
    if (typeof data === 'undefined' || !data)
        return null;
    return {
        id: data.ID || '',
        videoId: data.video_id || '',
        url: data.video_url || '',
        title: data.video_title || '',
        type: data.type || VideoType.VIDEO,
        totalView: data.total_view || 0,
        description: data.description || '',
        createTime: data.create_time || '',
        duration: data.duration || 0,
        image: data.image || '',
        imageMedium: data.image_medium || '',
        imageThumbnail: data.image_thumbnail || '',
        active: false,
        articleLink: data.article_link || '',
    };
};

var styles = {"gridContainer":"q3nL5cp","container":"_2DNf80G","closeWrapper":"Q-glX-n"};

const BtnClosePopup = ({ onClosePopup }) => {
    return (React__default.createElement("div", { className: `${styles.closeWrapper} close-btn`, onClick: onClosePopup },
        React__default.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
            React__default.createElement("path", { d: "M18 6L6 18M18 18L6 6", stroke: "#3E3F58", strokeWidth: "1.3", strokeLinecap: "round" }))));
};

const PopupWrapper = ({ onClosePopup, isDisplay, children, isNavMenu, hideCloseBtn, stylesContainer, }) => {
    return (React__default.createElement("div", { className: "hhgcomp-navigation-popupwrapper-menuwrapper top-menu-health-tools", "data-is-display": !!isDisplay, "data-is-nav-menu": !!isNavMenu },
        React__default.createElement(Container, { className: "hhgcomp-navigation-popupwrapper-menuwrapper-child" },
            !hideCloseBtn && (React__default.createElement("div", { className: styles.container },
                React__default.createElement(BtnClosePopup, { onClosePopup: onClosePopup }))),
            React__default.createElement(Container, { className: styles.gridContainer, style: stylesContainer }, children))));
};

const MenuCareList = ({ careSpecialties = [], isOpen, onClose, spotlights = [], }) => {
    var _a;
    const { t } = useTranslations();
    const { locale, configs: { statics }, } = useContext(NavigationContext);
    return (React__default.createElement(PopupWrapper, { onClosePopup: onClose, isDisplay: isOpen, isNavMenu: true },
        React__default.createElement(Categories, { headingTitle: t('home.navigator.menuItem.specialties'), hrefViewMore: `${statics.CARE_URL_FE}/`, UrlFE: statics.CARE_URL_FE, onClosePopup: onClose, titleBtnViewMore: t('home.navigator.menuItem.allSpecialties'), menuItems: (careSpecialties === null || careSpecialties === void 0 ? void 0 : careSpecialties.map((specialty) => {
                if (!specialty)
                    return {};
                return {
                    name: String(specialty.name) || '',
                    link: getCareSearchUrl({
                        type: 'DOCTOR',
                        specialtySlug: specialty.slug,
                        locale,
                    }),
                    thumbnail: (specialty === null || specialty === void 0 ? void 0 : specialty.thumbnail) || '',
                };
            })) || [] }),
        React__default.createElement(CareSpotlights, { spotlights: spotlights, hrefViewMore: `${statics.CARE_URL_FE}/${(_a = LOCALIZED_SLUGS[locale]) === null || _a === void 0 ? void 0 : _a.SPECIALTIES}/` })));
};

const MenuCategoriesList = ({ categories = [], spotlightsList = [], onClose, isOpen, }) => {
    const { t } = useTranslations();
    const { locale, configs: { statics }, } = useContext(NavigationContext);
    return (React__default.createElement(PopupWrapper, { onClosePopup: onClose, isDisplay: isOpen, isNavMenu: true },
        React__default.createElement(Categories, { hrefViewMore: `${statics.HOME_PAGE_URL}${locale === 'tl-PH' ? '/fil' : ''}/categories/`, UrlFE: statics.HOME_PAGE_URL, onClosePopup: onClose, titleBtnViewMore: t('home.navigator.menuItem.allCategories'), menuItems: (categories === null || categories === void 0 ? void 0 : categories.map((cat) => {
                if (!cat)
                    return {};
                return {
                    name: cat.displayName || null,
                    link: (cat === null || cat === void 0 ? void 0 : cat.customizedUrl) || (cat === null || cat === void 0 ? void 0 : cat.permalink) || '/',
                    thumbnail: cat.iconUrl || null,
                };
            })) || [], headingTitle: t('home.navigator.menuItem.healthCategories') }),
        React__default.createElement(CategorySpotlights, { spotlightsList: spotlightsList, hrefViewMore: `${statics.HOME_PAGE_URL}${locale === 'tl-PH' ? '/fil' : ''}/spotlight/` })));
};

const MenuCommunitiesList = ({ communities = [], onClose, isOpen, spotlights = [], }) => {
    const { t } = useTranslations();
    const { configs: { statics }, } = useContext(NavigationContext);
    return (React__default.createElement(PopupWrapper, { onClosePopup: onClose, isDisplay: isOpen, isNavMenu: true },
        React__default.createElement(Categories, { hrefViewMore: normalizeLink(statics.TOGETHER_URL_FE), UrlFE: normalizeLinkSlash(statics.TOGETHER_URL_FE), onClosePopup: onClose, titleBtnViewMore: t('home.navigator.menuItem.allCommunities'), menuItems: (communities === null || communities === void 0 ? void 0 : communities.map((community) => {
                if (!community)
                    return {};
                return {
                    name: community.name || '',
                    link: community.slug || '/',
                    thumbnail: community.thumbnail || '',
                };
            })) || [], headingTitle: t('home.navigator.menuItem.allCommunitiesheadingTitle') }),
        React__default.createElement(CommunitySpotlights, { spotlights: spotlights })));
};

const MenuHealthToolsList = ({ locale, onClose, isOpen, spotlightHealthTools = [], healthTools = [], }) => {
    var _a;
    const { t } = useTranslations();
    const { configs: { statics }, } = useContext(NavigationContext);
    const hrefViewMore = `${statics.HOME_PAGE_URL}${locale === 'tl-PH' ? '/fil' : ''}${((_a = STATIC_PAGES[locale]) === null || _a === void 0 ? void 0 : _a.HEALTH_TOOLS) || ''}`;
    return (React__default.createElement(PopupWrapper, { onClosePopup: onClose, isDisplay: isOpen, isNavMenu: true },
        React__default.createElement(Categories, { hrefViewMore: hrefViewMore, UrlFE: statics.HOME_PAGE_URL, onClosePopup: onClose, headingTitle: t('home.navigator.menuItem.healthToolsList'), titleBtnViewMore: t('home.navigator.menuItem.allHealthTools'), menuItems: healthTools.map((t) => ({
                name: t.title,
                link: t.link
                    ? t.link.startsWith('http')
                        ? t.link
                        : `${statics.HOME_PAGE_URL}${t.link}`
                    : undefined,
                thumbnail: t.icon,
                isMobileAppTool: t.isMobileAppTool,
            })) }),
        React__default.createElement(ToolSpotlights, { spotlightHealthTools: spotlightHealthTools, hrefViewMore: hrefViewMore })));
};

const MenuVideoList = ({ spotlightsList = [], onClose, isOpen }) => {
    const { t } = useTranslations();
    const { locale, configs: { statics }, } = useContext(NavigationContext);
    const listing = useMemo(() => [
        {
            name: t('home.navigator.menu.videos'),
            link: `${statics.VIDEO_URL_FE}/video/`,
            thumbnail: CommonGAssets.getAssetPath('nav-icons/video.svg'),
        },
        {
            name: t('home.navigator.menu.shorts'),
            link: `${statics.VIDEO_URL_FE}/short/`,
            thumbnail: CommonGAssets.getAssetPath('nav-icons/short.svg'),
        },
        // {
        //   name: t('home.navigator.menu.podcasts'),
        //   link: `${statics.VIDEO_URL_FE}/podcast/`,
        //   thumbnail: CommonGAssets.getAssetPath('nav-icons/podcast.svg'),
        // },
    ], []);
    return (React__default.createElement(PopupWrapper, { onClosePopup: onClose, isDisplay: isOpen, isNavMenu: true },
        React__default.createElement(Categories, { hrefViewMore: `${statics.HOME_PAGE_URL}${locale === 'tl-PH' ? '/fil' : ''}/videos/`, UrlFE: statics.HOME_PAGE_URL, onClosePopup: onClose, titleBtnViewMore: t('home.navigator.menuItem.allVideos'), menuItems: listing, headingTitle: t('home.navigator.menuItem.videoCategories') }),
        React__default.createElement(VideoSpotlights, { spotlightsList: spotlightsList })));
};

styled.div `
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  ${MediaQueries.tdDown} {
    gap: 12px;
    grid-template-columns: 1fr;
  }
`;
const StyleButton = styled(Button$1) `
  border: 1px solid ${theme.colors.white} !important;
  .mantine-Button-leftIcon {
    width: 24px;
    height: 24px;
  }
`;
const StyleWrapperIcon = styled.div `
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 5px;
  background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.1) 15.1%,
      rgba(0, 0, 0, 0.01) 100%
    ),
    linear-gradient(180deg, #65b5ff 0%, #2685f1 100%);
  background-blend-mode: soft-light, normal;
`;

const InitialCart = () => (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "512", height: "512", style: {
        width: '100%',
        height: '100%',
        contentVisibility: 'visible',
    }, viewBox: "0 0 512 512" },
    React__default.createElement("defs", null,
        React__default.createElement("clipPath", { id: "__lottie_element_2" },
            React__default.createElement("path", { d: "M0 0h512v512H0z" })),
        React__default.createElement("path", { fill: "#FFF", d: "m139 0-13 174h244l-30 292 165 1 4-466z", opacity: "1", id: "__lottie_element_6", display: "block" }),
        React__default.createElement("mask", { id: "__lottie_element_6_1", "mask-type": "alpha" },
            React__default.createElement("use", { xlinkHref: "#__lottie_element_6" }))),
    React__default.createElement("g", { clipPath: "url(#__lottie_element_2)" },
        React__default.createElement("path", { fill: "#2B62CD", d: "m430 181-40 41-111-120a18 18 0 0 1-5-13c0-5 2-9 5-13l6-5a18 18 0 0 1 25-1zm-348 0 40 41 111-120a18 18 0 0 0 0-26l-6-5a18 18 0 0 0-25-1z", display: "block" }),
        React__default.createElement("g", { display: "block" },
            React__default.createElement("path", { fill: "#2D87F3", d: "M385 427H125c-4 0-9-1-13-5a20 20 0 0 1-6-12L88 239h335l-18 171a20 20 0 0 1-7 12c-3 4-8 5-13 5" }),
            React__default.createElement("path", { fill: "#2B62CD", d: "m160 402-5-2a6 6 0 0 1-1-4l-8-114v-2a6 6 0 0 1 3-4 6 6 0 0 1 5 0 6 6 0 0 1 4 5l8 115-1 2a6 6 0 0 1-1 2 6 6 0 0 1-4 2m61 0-5-2a6 6 0 0 1-1-4l-2-114c0-2 0-3 2-5a6 6 0 0 1 4-1l4 1a6 6 0 0 1 2 4l2 115a6 6 0 0 1-2 4 6 6 0 0 1-4 2zm131 0a6 6 0 0 1-5-4l-1-2 8-115a6 6 0 0 1 2-4l2-1a6 6 0 0 1 2 0 6 6 0 0 1 5 2 6 6 0 0 1 1 4l-8 114a6 6 0 0 1-6 6m-61 0a6 6 0 0 1-6-6l2-114 2-5a6 6 0 0 1 4-1 6 6 0 0 1 5 1 6 6 0 0 1 1 5l-2 114a6 6 0 0 1-1 4 6 6 0 0 1-5 2" }),
            React__default.createElement("path", { fill: "#91CAFF", d: "M424 243H88a20 20 0 0 1-21-18l-3-28a20 20 0 0 1 20-23h344a20 20 0 0 1 20 23l-3 28a20 20 0 0 1-21 18" })),
        React__default.createElement("g", { mask: "url(#__lottie_element_6_1)", display: "block" },
            React__default.createElement("path", { fill: "#FFC326", d: "m294 198-16 123a5 5 0 0 1-5 5h-80l-4-2a5 5 0 0 1-1-4l15-115h1z" }),
            React__default.createElement("path", { fill: "#FFD658", d: "M272 189c0 3 0 7 2 10a12 12 0 0 0 10 6h-81l-3-1c-3-1-5-3-6-5a15 15 0 0 1 5-19 17 17 0 0 1 9-3h80c-4 0-7 1-9 3a15 15 0 0 0-7 9" }),
            React__default.createElement("path", { fill: "#FEA21E", d: "M277 326h-4c3 0 5-2 5-4l15-115 1-9v1l-1 1a9 9 0 0 1-5 4 11 11 0 0 1-8 0c-3-1-5-3-6-5-4-7-2-15 5-19 2-2 5-3 9-3h1c4 0 7 2 10 4l6 9 1 11 14 119-1 4z" }),
            React__default.createElement("path", { fill: "#FC7419", d: "M303 310v-74a3 3 0 1 0-5 0v74l-21 16h38l4-2zm-5-109a13 13 0 0 1-5 6l1-9c0-1 0 0 0 0 0-3-1-6-4-7a4 4 0 0 0-5 1v1c0 2-1 3-2 3a3 3 0 0 1-3-2l1-4a9 9 0 0 1 11-4c3 1 5 3 6 6v9" })),
        React__default.createElement("g", { display: "block" },
            React__default.createElement("path", { fill: "#FFC326", d: "m460 330-16 123a5 5 0 0 1-5 5h-80l-4-2a5 5 0 0 1-1-4l15-115h1z" }),
            React__default.createElement("path", { fill: "#FFD658", d: "M438 321c0 3 0 6 2 9a12 12 0 0 0 10 7h-81l-3-1c-3-1-5-3-6-6a15 15 0 0 1 5-18 17 17 0 0 1 9-3h80c-4 0-7 1-9 3a15 15 0 0 0-7 9" }),
            React__default.createElement("path", { fill: "#FEA21E", d: "M443 458h-4c3 0 5-2 5-5l15-114 1-9v1l-1 1a9 9 0 0 1-5 4 11 11 0 0 1-8 0c-3-1-5-3-6-6-4-6-2-14 5-18 2-2 5-3 9-3h1c4 0 7 2 10 4s5 5 6 9l1 11 14 119-1 4z" }),
            React__default.createElement("path", { fill: "#FC7419", d: "M469 442v-74a3 3 0 1 0-5 0v74l-21 16h38l4-2zm-5-109a13 13 0 0 1-5 6l1-9c0-1 0 0 0 0 0-3-1-6-4-7a4 4 0 0 0-4 1l-1 1-2 3a3 3 0 0 1-3-3l1-3a9 9 0 0 1 11-4c3 1 5 3 6 5 1 3 2 7 0 10" })))));

const InitialDoctor = () => (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "512", height: "512", style: {
        width: '100%',
        height: '100%',
        contentVisibility: 'visible',
    }, viewBox: "0 0 512 512" },
    React__default.createElement("defs", null,
        React__default.createElement("clipPath", { id: "__lottie_element_23" },
            React__default.createElement("path", { d: "M0 0h512v512H0z" }))),
    React__default.createElement("g", { clipPath: "url(#__lottie_element_23)" },
        React__default.createElement("g", { display: "block" },
            React__default.createElement("path", { fill: "#1B3250", d: "M430 332c-13-17-52-37-42-63 16-41-9-72-28-84-22-14-23-43-30-66-15-50-53-73-103-73s-88 21-103 71c-7 22-7 53-29 67-19 12-61 41-45 82 10 26-15 52-28 69-39 53 13 89 72 98l255 2c59-9 120-50 81-103" }),
            React__default.createElement("path", { fill: "#FFB497", d: "M120 202c-11 4-13 17-10 29a29 29 0 0 0 14 17 29 29 0 0 0 22 3l-8-49a25 25 0 0 0-18 0" }),
            React__default.createElement("path", { fill: "#FF977B", d: "M147 235a5 5 0 0 1-4-2c-6-8-17-8-17-8a5 5 0 0 1-4-2 5 5 0 0 1 0-7l4-1c1 0 16 0 25 11a5 5 0 0 1-4 9" }),
            React__default.createElement("path", { fill: "#FFB497", d: "M332 202a25 25 0 0 0-18 0l-8 49a29 29 0 0 0 22-3c7-3 12-10 14-17 3-12 1-25-10-29" }),
            React__default.createElement("path", { fill: "#FF977B", d: "M305 235a5 5 0 0 1-5-3 5 5 0 0 1 1-6c9-11 24-11 25-11a5 5 0 0 1 5 5 5 5 0 0 1-5 5s-11 0-17 8a5 5 0 0 1-4 2" }),
            React__default.createElement("path", { fill: "#E3F2FF", d: "M366 452H86a3 3 0 0 1-4-4c5-19 19-47 37-65a153 153 0 0 1 42-28l1-1a85 85 0 0 1 29-19h70a84 84 0 0 1 29 19l1 1a153 153 0 0 1 42 28c18 18 32 46 37 65a3 3 0 0 1-1 3 3 3 0 0 1-3 1" }),
            React__default.createElement("path", { fill: "#FCCAAF", d: "M261 335c-25 32-48 32-70 0l5-10v-1a45 45 0 0 0 2-13h56a48 48 0 0 0 2 13v1l5 10" }),
            React__default.createElement("path", { fill: "#2D87F3", d: "M281 452H175c-14-93 16-117 16-117 7 9 20 15 35 15s28-6 35-15c0 0 9 12 16 37 5 20 6 60 4 80" }),
            React__default.createElement("path", { fill: "#BCDEFF", d: "M191 335a84 84 0 0 0-30 19 53 53 0 0 0-13 28c0 3 11 1 16 0h1v1c-13 8-17 19-16 25 2 15 6 30 13 44h26s-12-72 3-117m96 48a1 1 0 0 1 0-1h1c1 0 0 0 0 0 5 1 16 3 16 0a53 53 0 0 0-13-28 83 83 0 0 0-30-19c15 45 3 117 3 117h26a157 157 0 0 0 13-44c1-6-3-17-16-25" }),
            React__default.createElement("path", { fill: "#FF977B", d: "M256 325c-20 18-40 18-60 0v-1a46 46 0 0 0 2-13h56a48 48 0 0 0 2 13v1" }),
            React__default.createElement("path", { fill: "#FCCAAF", d: "M314 205c-3 54-17 80-39 96-14 11-37 24-49 24s-35-13-49-24c-22-16-36-42-39-96 52-21 30-127 85-99a7 7 0 0 0 6 0c55-28 33 78 85 99" }),
            React__default.createElement("path", { fill: "#FFB497", d: "M221 106c-27-12-34 12-43 40-7 25-16 54-41 63l1 3c43 0 71-62 83-106" })),
        React__default.createElement("path", { fill: "#FF977B", d: "M233 233a5 5 0 0 0-4 2l-3 1-3-1a5 5 0 0 0-2-2 5 5 0 0 0-4 0 5 5 0 0 0-3 5c0 6 9 8 12 8s12-2 12-8a5 5 0 0 0-2-3 5 5 0 0 0-3-2", display: "block" }),
        React__default.createElement("path", { fill: "#1B3250", d: "m261 199 9-5a27 27 0 0 1 11-1c4 0 7 0 11 2l8 4a2 2 0 0 1 1 2 2 2 0 0 1 0 1h-1l-10-1h-9a20 20 0 0 0-7 2 65 65 0 0 0-7 4 5 5 0 0 1-4 1 5 5 0 0 1-3-2 5 5 0 0 1-1-2 5 5 0 0 1 2-5", display: "block" }),
        React__default.createElement("path", { fill: "#284A75", d: "M280 218a9 9 0 1 0 0-19 9 9 0 0 0 0 19", display: "block" }),
        React__default.createElement("path", { fill: "#1B3250", d: "m192 210-7-4-7-2h-9l-9 1a2 2 0 0 1-2-1v-1l1-1 9-4c3-2 6-2 10-2 4-1 7 0 11 1l9 5a5 5 0 0 1 2 3v4a5 5 0 0 1-7 2l-1-1", display: "block" }),
        React__default.createElement("path", { fill: "#284A75", d: "M184 218a9 9 0 1 0 0-19 9 9 0 0 0 0 19", display: "block" }),
        React__default.createElement("g", { fill: "#FFF", display: "block" },
            React__default.createElement("path", { d: "m216 213-4-1a5 5 0 0 1-1-3v-4a5 5 0 0 1 3-2 33 33 0 0 1 24 0 5 5 0 0 1 3 7 5 5 0 0 1-3 2h-3a23 23 0 0 0-18 1h-1" }),
            React__default.createElement("path", { d: "M183 249a38 38 0 0 1-35-23 38 38 0 0 1-2-22 38 38 0 0 1 11-19 38 38 0 0 1 19-11c7-1 15 0 22 2a38 38 0 0 1 16 14 38 38 0 0 1 7 21 38 38 0 0 1-11 27 38 38 0 0 1-27 11m0-65a27 27 0 0 0-25 17 27 27 0 0 0-2 15 27 27 0 0 0 8 14 27 27 0 0 0 42-4c3-4 4-9 4-15a27 27 0 0 0-8-19 27 27 0 0 0-19-8zm86 65a38 38 0 0 1-35-24 38 38 0 0 1 27-51 38 38 0 0 1 39 16 38 38 0 0 1 6 21 38 38 0 0 1-11 27 38 38 0 0 1-26 11m0-65a27 27 0 0 0-25 17 27 27 0 0 0-2 15 27 27 0 0 0 8 14 27 27 0 0 0 46-19 27 27 0 0 0-8-19 27 27 0 0 0-19-8z" })),
        React__default.createElement("path", { d: "m205 180-2-1c-10-4-39-9-47-1a5 5 0 0 1-3 2 5 5 0 0 1-4-2 5 5 0 0 1-2-3l1-4c14-15 52-4 59-1a5 5 0 0 1 3 6 5 5 0 0 1-2 3l-3 1zm42 0-3-1a5 5 0 0 1-1-7 5 5 0 0 1 2-2c7-3 45-14 59 1a5 5 0 0 1 1 4l-2 3a5 5 0 0 1-4 2l-3-2c-8-8-37-3-47 1l-2 1", fill: "#284A75", display: "block" }),
        React__default.createElement("path", { fill: "#FF886C", d: "M208 260a4 4 0 0 0-3 1 4 4 0 0 0-1 3c2 8 6 19 22 19s21-11 22-19a4 4 0 0 0-4-4l-18-1-18 1", display: "block" }),
        React__default.createElement("g", { display: "block" },
            React__default.createElement("g", { fill: "#FFF" },
                React__default.createElement("path", { d: "M469 405a85 85 0 1 1-170 0 85 85 0 0 1 170 0" }),
                React__default.createElement("path", { d: "M469 405a85 85 0 1 1-170 0 85 85 0 0 1 170 0" })),
            React__default.createElement("path", { fill: "#E4E8EC", d: "M384 480a75 75 0 1 0 0-149 75 75 0 0 0 0 149m0 11a85 85 0 1 0 0-171 85 85 0 0 0 0 171" }),
            React__default.createElement("path", { fill: "#FFF", d: "M469 405a85 85 0 1 1-170 0 85 85 0 0 1 170 0" }),
            React__default.createElement("path", { fill: "#E4E8EC", d: "M384 480a75 75 0 1 0 0-149 75 75 0 0 0 0 149m0 11a85 85 0 1 0 0-171 85 85 0 0 0 0 171" }),
            React__default.createElement("path", { fill: "#FF6F4D", d: "M389 358h-11a17 17 0 0 0-12 5 17 17 0 0 0-5 12v3l-1 3a4 4 0 0 1-3 1h-3a17 17 0 0 0-17 17v12a17 17 0 0 0 17 17h3a4 4 0 0 1 4 3v3a17 17 0 0 0 17 17h11c5 0 9-2 12-5s5-7 5-12v-3a4 4 0 0 1 4-3h3c4 0 9-2 12-5s5-8 5-12v-12c0-5-2-9-5-12a17 17 0 0 0-12-5h-3a4 4 0 0 1-4-4v-3a17 17 0 0 0-5-12 17 17 0 0 0-12-5" })))));

const MenuViewMore = ({ menuItems = [], isOpen, onClose }) => {
    const { locale, configs: { enableAppIntroPage }, } = useContext(NavigationContext);
    const ecomNavItem = menuItems.find((m) => m.id === 'ecom');
    const careNavItem = menuItems.find((m) => m.id === 'care');
    return (React__default.createElement(PopupWrapper, { onClosePopup: onClose, isDisplay: isOpen, isNavMenu: true, hideCloseBtn: true, stylesContainer: {
            display: 'flex',
            gap: 0,
            padding: 0,
        } },
        ecomNavItem && (React__default.createElement("a", { tabIndex: 0, href: ecomNavItem.link, "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": ecomNavItem.link },
            React__default.createElement(StyleButton, { variant: "tertiary", leftIcon: React__default.createElement(InitialCart, null) }, ecomNavItem.name))),
        careNavItem && (React__default.createElement("a", { tabIndex: 0, href: careNavItem.link, "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": careNavItem.link },
            React__default.createElement(StyleButton, { variant: "tertiary", leftIcon: React__default.createElement(InitialDoctor, null) }, careNavItem.name))),
        enableAppIntroPage && (React__default.createElement("a", { tabIndex: 0, href: "https://applink.hellobacsi.com/o9Q88rQh7Mb", "data-event-category": "Hamburger Navigation", "data-event-action": "Click", "data-event-label": `https://applink.hellobacsi.com/o9Q88rQh7Mb` },
            React__default.createElement(StyleButton, { variant: "tertiary", leftIcon: React__default.createElement(StyleWrapperIcon, null,
                    React__default.createElement(Logo, { width: 16, height: 15 })) }, `${LOCALE_SPECS[locale || 'en-PH'].SITE_NAME_FORMATTED} App`)))));
};

const NavigationBar = ({ onTopBarAppears, languageMenu, menuItems, logoComponent, subHead, projectType, }) => {
    var _a, _b;
    const { siteType, isMobile = false, locale, sitewideBanner, sitewideBannerShown = true, sponsorComponent, isHomepage = false, 
    // onBookingClick,
    currentUrl, onLoginClick, cartNumber, 
    // ssrMenuContent: { categories, healthTools, care, together },
    configs: { statics, 
    // enableNavCareBooking,
    enableSearchBar, enableNavChatbotAi, enableAppIntroPage,
    // enableNavVideo,
    // enableNavCare,
    // enableProfileMyHealth,
    // enableProfileMySaved,
    // enableNavTogether,
    // enableProfileEcom,
     }, userState: { userInfo }, onLogout, 
    // userProfileRouterPush,
    isUserLoading, } = useContext(NavigationContext);
    const { triggerLogin } = useSSOV2Store();
    const { SSO_URL, HOME_PAGE_URL } = statics;
    const isSponsored = !!sponsorComponent;
    const [isCollapsed, setIsCollapsed] = useState(false);
    const scrollY = useRef(47);
    const headerRef = useRef(null);
    const collapsedMenu = useRef(false);
    const goToLogin = () => {
        if (IS_SSOV2_ENABLED(locale))
            return triggerLogin();
        const currentLocation = window.location.href;
        window.location.href = SSO_URL
            ? normalizeLinkSlash(`${SSO_URL}?returnUrl=${currentLocation}`)
            : currentLocation;
    };
    const logoType = siteType === 'helloSites'
        ? (_a = LOCALE_SPECS[locale]) === null || _a === void 0 ? void 0 : _a.LOGO_TYPE
        : siteType;
    const isBrowser = typeof window !== 'undefined';
    const scrolling = useCallback(throttle(() => {
        if (isBrowser) {
            if (!headerRef.current)
                return;
            const COLLAPSE_THRESHOLD = 30;
            const headerBoundingRect = headerRef.current.getBoundingClientRect();
            if (headerBoundingRect.top <= 0 &&
                window.scrollY > scrollY.current + COLLAPSE_THRESHOLD &&
                window.scrollY > headerBoundingRect.height + 20 &&
                !collapsedMenu.current) {
                collapsedMenu.current = true;
                setIsCollapsed(true);
            }
            if (window.scrollY < scrollY.current - COLLAPSE_THRESHOLD &&
                collapsedMenu.current) {
                collapsedMenu.current = false;
                setIsCollapsed(false);
            }
            if (window.scrollY >= 0)
                scrollY.current = window.scrollY;
        }
    }, 200), []);
    useEffect(() => {
        onTopBarAppears === null || onTopBarAppears === void 0 ? void 0 : onTopBarAppears(!isCollapsed);
    }, [isCollapsed]);
    useEffect(() => {
        window.addEventListener('scroll', scrolling, { passive: true });
        return () => {
            window.removeEventListener('scroll', scrolling);
        };
    }, []);
    useEffect(() => {
        if (isMobile)
            scrolling();
    }, [isMobile]);
    const isShowingSiteWideBanner = sitewideBannerShown && !!sitewideBanner;
    return (React__default.createElement(StyledHeaderWrapper, { "data-site-type": siteType, "data-sponsored": isSponsored, "data-sitewide-banner-shown": isShowingSiteWideBanner, "data-header-type": "home", "data-collapsed": isCollapsed, "data-is-displayed": true, id: "site-header", ref: headerRef },
        sitewideBanner,
        React__default.createElement(StyledHeader, { "data-site-type": siteType },
            React__default.createElement(StyledLeftGroup, { "data-site-type": siteType },
                isMobile && (React__default.createElement(HamburgerMenu, { menuItems: menuItems.filter((m) => !!m.link), isHomepage: isHomepage, projectType: projectType })),
                logoComponent || (React__default.createElement("a", { style: {
                        flexShrink: 0,
                    }, href: HOME_PAGE_URL },
                    React__default.createElement("div", null,
                        React__default.createElement(Logo$1, { style: {
                                display: 'flex',
                            }, type: logoType, badge: locale === 'id-ID' && (React__default.createElement("img", { src: CommonGAssets.getAssetPath('sehat-badge.png'), width: "56", height: "23", loading: "lazy" })), dateForSeasonal: new Date(), locale: locale, key: typeof window !== 'undefined' ? 'client' : 'server' })))),
                !isMobile && (React__default.createElement(React__default.Fragment, null, siteType === 'marryBaby' ? (React__default.createElement(NavigationMenu, { menuItems: menuItems, originalMenuItems: menuItems })) : (enableSearchBar && (React__default.createElement(NavigtionSearch, { siteType: siteType, projectType: projectType, isMobile: isMobile })))))),
            React__default.createElement(StyledRightGroup, { "data-site-type": siteType },
                !isMobile && siteType !== 'marryBaby' && (React__default.createElement(NavigationMenu, { menuItems: menuItems.filter((m) => m.id !== 'ecom' && m.id !== 'care'), originalMenuItems: menuItems })),
                React__default.createElement(StyledProfileNavGroup, null,
                    languageMenu,
                    enableNavChatbotAi && (React__default.createElement(Box, { component: "a", href: `${getCurrentBaseUrl(locale)}/ai-doctor`, "data-event-category": "Chatbot AI", "data-event-action": "Open", "data-event-label": "Hamburger Navigation", className: "ai-doctor-nav-item" },
                        React__default.createElement(StyleButtonAiChat, { variant: "tertiary", leftIcon: React__default.createElement(ChatAi, { size: 18, color: "#2F8AF2" }), size: "md", className: "ai-doctor-btn" }, (_b = LOCALE_SPECS[locale]) === null || _b === void 0 ? void 0 :
                            _b.SITE_NAME,
                            " AI"))),
                    React__default.createElement(NavigationProfileButton, { userInfo: userInfo, siteType: siteType, onLoginClick: onLoginClick || goToLogin, 
                        // SSO_URL={normalizeLink(statics.SSO_URL)}
                        currentUrl: currentUrl, onLogout: onLogout, isLoading: isUserLoading, locale: locale, enableAppIntroPage: enableAppIntroPage, isMobile: isMobile }),
                    cartNumber !== undefined && (React__default.createElement(React__default.Fragment, null,
                        !isMobile && (React__default.createElement("hr", { style: {
                                height: 20,
                                width: 0,
                                border: 'none',
                                borderLeft: '1px solid #E4E8EC',
                            } })),
                        React__default.createElement(CartBadge, { "data-cart-menu": "true", "data-event-category": "Ecommerce", "data-event-action": "Cart Click", "data-event-label": currentUrl, count: cartNumber, locale: locale })))))),
        isMobile && isHomepage && (React__default.createElement(StyleWrapperNavigtionSearch, null,
            React__default.createElement(NavigtionSearch, { siteType: siteType, projectType: projectType, isMobile: isMobile, isHomepage: isHomepage }))),
        sponsorComponent
            ? !React__default.isValidElement(sponsorComponent)
                ? sponsorComponent
                : React__default.cloneElement(sponsorComponent, {
                    isCollapsed,
                    locale,
                    isMobile,
                })
            : null,
        subHead && subHead));
};
const NavigtionSearch = ({ siteType, projectType, isMobile = false, isHomepage = false, isRedirectSearchPage = false, }) => (React__default.createElement(DisplayWrapper, { mediaQueryKey: "mbUp", className: `${siteType === 'marryBaby' ? 'marry-baby' : ''} ${isHomepage ? 'block-show' : ''}` },
    React__default.createElement(SearchInput, { id: "desktop", projectType: projectType, isMobile: isMobile, isHomepage: isHomepage, isRedirectSearchPage: isRedirectSearchPage })));
const NavigationMenu = ({ menuItems, originalMenuItems, }) => {
    const { siteType, locale, ssrMenuContent: { categories, healthTools, care, together, videos }, } = useContext(NavigationContext);
    return (React__default.createElement(DisplayWrapper, { mediaQueryKey: "mbUp", style: { height: '100%' } },
        React__default.createElement(StyledWrapMenuItems, { "data-site-type": siteType }, menuItems === null || menuItems === void 0 ? void 0 : menuItems.map((menuItem, index) => (React__default.createElement(ItemMenu, { key: index, item: menuItem, menu: menuItem.popupType === 'categories' ? (React__default.createElement(MenuCategoriesList, { categories: categories === null || categories === void 0 ? void 0 : categories.items, spotlightsList: categories === null || categories === void 0 ? void 0 : categories.spotlights })) : menuItem.popupType === 'tools' ? (React__default.createElement(MenuHealthToolsList, { locale: locale, healthTools: healthTools === null || healthTools === void 0 ? void 0 : healthTools.items, spotlightHealthTools: healthTools === null || healthTools === void 0 ? void 0 : healthTools.spotlights })) : menuItem.popupType === 'together' ? (React__default.createElement(MenuCommunitiesList, { communities: together === null || together === void 0 ? void 0 : together.items, spotlights: together === null || together === void 0 ? void 0 : together.spotlights })) : menuItem.popupType === 'care' ? (React__default.createElement(MenuCareList, { careSpecialties: care === null || care === void 0 ? void 0 : care.items, spotlights: care === null || care === void 0 ? void 0 : care.spotlights })) : menuItem.popupType === 'video' ? (React__default.createElement(MenuVideoList, { spotlightsList: videos === null || videos === void 0 ? void 0 : videos.spotlights })) : menuItem.popupType === 'other' ? (React__default.createElement(MenuViewMore, { menuItems: originalMenuItems })) : null }))))));
};

const useHeaderHeight = ({ hasSponsoredBanners, isSponsored, isShowingSiteWideBanner, isMobile, }) => {
    const headerRef = useRef(null);
    const [headerHeight, setHeaderHeight] = useState(0);
    const [headerBottom, setHeaderBottom] = useState(64);
    const debounceSetHeader = useCallback(debounce(() => {
        var _a, _b, _c, _d;
        const newHeaderHeight = ((_a = headerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) ||
            ((_c = (_b = headerRef.current) === null || _b === void 0 ? void 0 : _b.children[0]) === null || _c === void 0 ? void 0 : _c.clientHeight) ||
            0;
        // limit recalculation to once per 200ms + less than 300px from top of page
        if (window.scrollY <= newHeaderHeight + 200) {
            setHeaderHeight(newHeaderHeight);
            setHeaderBottom(((_d = headerRef.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect().bottom) || headerHeight);
            // setTimeout(() => debounceSetHeader(), 200)
        }
    }, 200), []);
    useEffect(() => {
        window.addEventListener('resize', debounceSetHeader, {
            passive: true,
        });
        window.addEventListener('scroll', debounceSetHeader, {
            passive: true,
        });
        debounceSetHeader();
        return () => {
            window.removeEventListener('resize', debounceSetHeader);
            window.removeEventListener('scroll', debounceSetHeader);
        };
    }, []);
    useEffect(() => {
        debounceSetHeader();
    }, [
        isMobile,
        isShowingSiteWideBanner,
        isSponsored,
        hasSponsoredBanners,
        headerRef.current,
    ]);
    const defaultHeaderHeight = useMemo(() => {
        let res = isMobile ? 56 : 56;
        if (isShowingSiteWideBanner) {
            res += 64;
        }
        if (isSponsored) {
            res += 40;
            if (hasSponsoredBanners) {
                res += 57;
            }
        }
        return res;
    }, [isMobile, isShowingSiteWideBanner, hasSponsoredBanners, isSponsored]);
    return {
        defaultHeaderHeight,
        headerHeight: headerHeight || defaultHeaderHeight,
        headerBottom,
        headerRef,
    };
};

const useInsider = () => {
    const { isFirstLogin, userState } = useContext(NavigationContext);
    const { userInfo } = userState;
    useEffect(() => {
        if (userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) {
            if (isFirstLogin) {
                // sign up
                (userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) !== ''
                    ? (() => {
                        window.insider_object = {
                            user: Object.assign({ uuid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id, email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email, gdpr_optin: true, email_optin: true, sign_up: true }, ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) ? { name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name } : {})),
                        };
                    })()
                    : (() => {
                        window.insider_object = {
                            user: Object.assign({ uuid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id, sign_up: true }, ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) ? { name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name } : {})),
                        };
                    })();
            }
            else {
                // log in
                (userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.email) !== ''
                    ? (() => {
                        window.insider_object = {
                            user: Object.assign({ uuid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id, email: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email, gdpr_optin: true, email_optin: true, log_in: true }, ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) ? { name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name } : {})),
                        };
                    })()
                    : (() => {
                        window.insider_object = {
                            user: Object.assign({ uuid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id, log_in: true }, ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) ? { name: userInfo === null || userInfo === void 0 ? void 0 : userInfo.name } : {})),
                        };
                    })();
            }
        }
    }, []);
};

const useNavServices = () => {
    const { t } = useTranslations();
    const { siteType, locale, configs: { enableNavDiscover, enableNavHealthTools, enableNavCare, enableNavTogether, enableNavEcom, enableNavVideo, enableAppIntroPage, statics, }, } = useContext(NavigationContext);
    const isMarryBaby = siteType === 'marryBaby';
    const enableNavViewMore = enableAppIntroPage || enableNavCare || enableNavEcom;
    const services = useMemo(() => {
        var _a;
        const _services = [];
        enableNavDiscover &&
            _services.push({
                name: t('home.navigator.menuItem.discover'),
                id: 'categories',
                link: `${statics.HOME_PAGE_URL}${locale === 'tl-PH' ? '/fil' : ''}/categories/`,
                niceName: '',
                thumbnail: isMarryBaby
                    ? CommonGAssets.getAssetPath('categories-mb.svg')
                    : CommonGAssets.getAssetPath('nav-icons/discover.svg'),
                popupType: 'categories',
            });
        enableNavVideo &&
            _services.push({
                name: t('home.navigator.menuItem.video'),
                id: 'video',
                link: `${statics.HOME_PAGE_URL}${locale === 'tl-PH' ? '/fil' : ''}/videos/`,
                niceName: '',
                thumbnail: CommonGAssets.getAssetPath('nav-icons/video.svg'),
                popupType: 'video',
            });
        enableNavHealthTools &&
            _services.push({
                name: t('home.navigator.menuItem.healthTools'),
                id: 'tools',
                link: `${statics.HOME_PAGE_URL}${locale === 'tl-PH' ? '/fil' : ''}${((_a = STATIC_PAGES[locale]) === null || _a === void 0 ? void 0 : _a.HEALTH_TOOLS) || ''}`,
                thumbnail: isMarryBaby
                    ? CommonGAssets.getAssetPath('healthtools-mb.svg')
                    : CommonGAssets.getAssetPath('nav-icons/health-tools.svg'),
                popupType: 'tools',
            });
        enableNavTogether &&
            _services.push({
                name: t('home.navigator.menuItem.helloTogether'),
                id: 'together',
                link: normalizeLinkSlash(statics.TOGETHER_URL_FE + '/'),
                thumbnail: isMarryBaby
                    ? CommonGAssets.getAssetPath('community-mb.svg')
                    : CommonGAssets.getAssetPath('nav-icons/community.svg'),
                popupType: 'together',
            });
        enableNavEcom &&
            _services.push({
                name: t('home.navigator.menuItem.helloEcom'),
                id: 'ecom',
                link: normalizeLinkSlash(statics.HOME_PAGE_URL + '/shop'),
                thumbnail: CommonGAssets.getAssetPath('nav-icons/shop.svg'),
                popupType: null,
            });
        enableNavCare &&
            _services.push({
                name: t('home.navigator.menuItem.helloCare'),
                id: 'care',
                link: normalizeLinkSlash(statics.HOME_PAGE_URL + '/care'),
                thumbnail: CommonGAssets.getAssetPath('nav-icons/care.svg'),
                popupType: locale === 'id-ID' ? 'care' : null,
            });
        enableNavViewMore &&
            _services.push({
                name: t('home.seeMore'),
                id: 'other',
                link: '',
                thumbnail: '',
                popupType: 'other',
                icon: (React__default.createElement(HamburgerIcon, { siteType: siteType, enableSearch: false, style: {
                        width: '16px',
                        height: '16px',
                    }, className: "mobile-hamburger-icon" })),
            });
        return _services;
    }, []);
    return services;
};

const StyledContainer = styled.div `
  --header-z-index: 305;
  top: 0;
  z-index: var(--header-z-index);

  ${MediaQueries.mbDown} {
    width: 100vw;
    max-width: 100%;
  }
  --amp-site-wide-closed: 2px;

  -webkit-transform: translateZ(0);
  position: sticky;

  &.nav-open {
    margin-top: 64px;
  }

  &:not(.nav-open) {
    --amp-site-wide-closed: 66px;
  }
  pointer-events: none;
  > section *:not([data-cart-menu] *) {
    pointer-events: auto;
  }
`;

const _NavigationV2 = (props) => {
    var _a, _b;
    const { isMobile, locale, onTopBarAppears, languageOptions, sponsorComponent, sitewideBanner, sitewideBannerShown, className, logoComponent, subHead, projectType, } = props;
    const services = useNavServices();
    useInsider();
    const isShowingSiteWideBanner = sitewideBannerShown && !!sitewideBanner;
    const isSponsored = !!sponsorComponent;
    const hasSponsoredBanners = !!((_b = (_a = sponsorComponent === null || sponsorComponent === void 0 ? void 0 : sponsorComponent.props) === null || _a === void 0 ? void 0 : _a.sponsoredBy) === null || _b === void 0 ? void 0 : _b.length);
    const { headerRef, defaultHeaderHeight, headerHeight, headerBottom } = useHeaderHeight({
        isShowingSiteWideBanner,
        isSponsored,
        hasSponsoredBanners,
        isMobile,
    });
    return (React__default.createElement(StyledContainer, { id: "navigation-v2", style: {
            '--default-header-height': defaultHeaderHeight + 'px',
            '--header-height': `calc(${headerHeight}px - var(--amp-site-wide-closed), 64px)`,
            '--header-bottom': headerBottom + 'px',
        }, className: className },
        React__default.createElement("section", { ref: headerRef },
            React__default.createElement(NavigationBar, { menuItems: services, onTopBarAppears: onTopBarAppears, logoComponent: logoComponent, subHead: subHead, projectType: projectType, languageMenu: React__default.createElement(LanguageSwitcher, { languageOptions: languageOptions, locale: locale }) }))));
};
const NavigationV2 = (props) => {
    const propsWithDefaultValues = Object.assign({ siteType: 'helloSites', projectType: 'discover', locale: 'vi-VN', activeMenuService: 'categories', ssrMenuContent: {} }, props);
    return (React__default.createElement(NavigationProvider, Object.assign({}, propsWithDefaultValues),
        React__default.createElement(_NavigationV2, Object.assign({}, propsWithDefaultValues))));
};
const getNavMenuContent = (locale) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const res = {};
    const isMarryBaby = locale === 'vi-VN_MB';
    try {
        const customLang = locale === 'tl-PH' ? 'lang=fil' : '';
        try {
            const [categories, spotlights, healthtools, healthtoolsFavorites, videos,] = yield Promise.all([
                fetch(normalizeLinkSlash(`${getDiscoverApiDomain(locale)}/wp-json/api/categories${customLang ? '?' + customLang : ''}`)).then((res) => res.json()),
                fetch(normalizeLinkSlash(`${getDiscoverApiDomain(locale)}/wp-json/api/spotlights?per_page=10&order_by=start_date${customLang ? '&' + customLang : ''}`)).then((res) => res.json()),
                fetch(normalizeLinkSlash(`${getDiscoverApiDomain(locale)}/wp-json/api/${isMarryBaby ? 'health-tools' : 'healthtools'}${customLang ? '?' + customLang : ''}`)).then((res) => res.json()),
                fetch(normalizeLinkSlash(`${getDiscoverApiDomain(locale)}/wp-json/api/${isMarryBaby ? 'health-tools' : 'healthtools'}/favorites${customLang ? '?' + customLang : ''}`)).then((res) => res.json()),
                locale === LOCALE.Vietnam &&
                    fetch(normalizeLinkSlash(`${getDiscoverApiDomain(locale)}/wp-json/api/video/navigation`)).then((res) => res.json()),
            ]);
            res.categories = {
                items: ((_b = (_a = categories === null || categories === void 0 ? void 0 : categories.data) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, formatCategory)) || [],
                spotlights: ((_f = (_e = (_d = (_c = spotlights === null || spotlights === void 0 ? void 0 : spotlights.data) === null || _c === void 0 ? void 0 : _c.articles) === null || _d === void 0 ? void 0 : _d.map) === null || _e === void 0 ? void 0 : _e.call(_d, formatSpotlightsList)) === null || _f === void 0 ? void 0 : _f.filter(checkAvailableSpotlight)) || [],
            };
            res.healthTools = {
                items: ((_h = (_g = healthtools === null || healthtools === void 0 ? void 0 : healthtools.data) === null || _g === void 0 ? void 0 : _g.map) === null || _h === void 0 ? void 0 : _h.call(_g, formatHealthTool)) || [],
                spotlights: ((_k = (_j = healthtoolsFavorites === null || healthtoolsFavorites === void 0 ? void 0 : healthtoolsFavorites.data) === null || _j === void 0 ? void 0 : _j.map) === null || _k === void 0 ? void 0 : _k.call(_j, formatHealthTool)) || [],
            };
            res.videos = {
                spotlights: ((_m = (_l = videos === null || videos === void 0 ? void 0 : videos.data) === null || _l === void 0 ? void 0 : _l.videos) !== null && _m !== void 0 ? _m : []).map(formatVideoItem),
            };
        }
        catch (_1) { }
        if (isMarryBaby || TOGETHER_LOCALES.includes(locale)) {
            try {
                const [communities, spotlightPosts] = yield Promise.all([
                    fetch(normalizeLinkSlash(`${getTogetherApiDomain()}/api/v1/community?website_url=https://${domainLocales[locale]}`)).then((res) => res.json()),
                    fetch(normalizeLinkSlash(`${getTogetherApiDomain()}/api/v1/options?website_url=https://${domainLocales[locale]}&meta_key=popular_post`)).then((res) => res.json()),
                ]);
                res.together = {
                    items: ((_q = (_p = (_o = communities === null || communities === void 0 ? void 0 : communities.data) === null || _o === void 0 ? void 0 : _o.communities) === null || _p === void 0 ? void 0 : _p.map) === null || _q === void 0 ? void 0 : _q.call(_p, formatCommunity)) || [],
                    spotlights: ((_t = (_s = (_r = spotlightPosts === null || spotlightPosts === void 0 ? void 0 : spotlightPosts.data) === null || _r === void 0 ? void 0 : _r.posts) === null || _s === void 0 ? void 0 : _s.map) === null || _t === void 0 ? void 0 : _t.call(_s, formatPost)) || [],
                };
            }
            catch (_2) { }
        }
        if (CARE_LOCALES.includes(locale)) {
            try {
                const [specialties, hospitals] = yield Promise.all([
                    fetch(normalizeLinkSlash(getCareApiDomain() +
                        `/api/options/setting_menu?site=${domainLocales[locale]}&type=0`)).then((res) => res.json()),
                    fetch(normalizeLinkSlash(getCareApiDomain() +
                        `/api/options/setting_menu?site=${domainLocales[locale]}&type=1`)).then((res) => res.json()),
                ]);
                res.care = {
                    items: ((_x = (_w = (_v = (_u = specialties === null || specialties === void 0 ? void 0 : specialties._data) === null || _u === void 0 ? void 0 : _u.setting_menu) === null || _v === void 0 ? void 0 : _v.menu_specialty) === null || _w === void 0 ? void 0 : _w.map) === null || _x === void 0 ? void 0 : _x.call(_w, formatSpecialties)) || [],
                    spotlights: ((_0 = (_z = (_y = hospitals === null || hospitals === void 0 ? void 0 : hospitals._data.setting_menu) === null || _y === void 0 ? void 0 : _y.menu_hospital) === null || _z === void 0 ? void 0 : _z.map) === null || _0 === void 0 ? void 0 : _0.call(_z, formatHospital)) || [],
                };
            }
            catch (_3) { }
        }
    }
    catch (e) {
        console.error(e);
    }
    return res;
});
const getNavMenuContentWithCache = (locale) => __awaiter(void 0, void 0, void 0, function* () {
    return (yield getDataWithCache('nav-menu-content', () => getNavMenuContent(locale || 'en-PH'), (data) => { var _a, _b; return !!((_b = (_a = data === null || data === void 0 ? void 0 : data.categories) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length); })) || {};
});

export { NavigationV2 as N, getNavMenuContentWithCache as a, getTogetherUserPostsApiPath as b, getNavMenuContent as g };
